function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('nav-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);


  if (elementToFocus) {
    // preventScroll: focusing a modal/drawer element must not scroll the page
    // underneath (e.g. the drawer is mid-slide/off-screen on open). AAS-1169
    elementToFocus.focus({ preventScroll: true });
  }

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}


function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const button = event.target.closest('button');
    if (!button) return;
    const previousValue = this.input.value;

    if (button.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && button.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/* Locale-aware path for Section Rendering API (cart drawer, line items, etc.).
   Must match the page the shopper is on — NOT routes.cart_url — or Shopify
   re-renders sections in the wrong market/locale (English + stale currency). */
function getSectionsUrl() {
  const root = (window.theme?.routes?.root_url || window.Shopify?.routes?.root || '/').replace(/\/$/, '');
  let path = `${window.location.pathname}${window.location.search || ''}`;

  if (root && root !== '/' && !window.location.pathname.startsWith(root)) {
    const suffix = window.location.pathname.startsWith('/') ? window.location.pathname : `/${window.location.pathname}`;
    path = `${root}${suffix}${window.location.search || ''}`;
  }

  if (window.pageNumber) {
    const sep = path.includes('?') ? '&' : '?';
    return `${path}${sep}page=${window.pageNumber}`;
  }

  return path;
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};



// One MQL object shared by NavDrawer — navigateTo/goBack/onInnerResize read it
// per interaction, so don't re-parse the media query on every call.
const navReduceMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

// Desktop cutover for the mobile drawer — must stay in sync with
// component-nav-drawer.css (burger hidden / drawer-open header rules at 1024px).
const navDesktopMQ = window.matchMedia('(min-width: 1024px)');

class NavDrawer extends HTMLElement {
  constructor() {
    super();
    this.viewport = this.querySelector('.nav-drawer__viewport');
    this.panels = this.querySelectorAll('.nav-drawer__panel');
    this.sharedHeader = this.querySelector('.nav-drawer__header');
    this.isOpen = false;
    this.history = ['l1'];
    this.burgerBtn = null;

    this.addEventListener('keyup', (e) => this.onKeyUp(e));

    this.querySelectorAll('[data-open-panel]').forEach((btn) =>
      btn.addEventListener('click', (e) => this.navigateTo(e.currentTarget.dataset.openPanel))
    );
    this.querySelectorAll('[data-go-back]').forEach((btn) =>
      btn.addEventListener('click', () => this.goBack())
    );

    // Auto-collapse: clicking anything that leaves the menu — a real link (nav
    // item, account, cart/basket, logo, Shop all) or an overlay opener (store
    // finder, search, wishlist) — closes the drawer. In-drawer panel navigation
    // (data-open-panel, incl. the language panel), the Back button and the
    // placeholder skip link are excluded. AAS-1169
    this.addEventListener('click', (e) => {
      const el = e.target.closest('a[href], [data-open-store-locator], [data-drawer-open]');
      if (!el) return;
      if (el.hasAttribute('data-open-panel')) return; // panel switch, not an exit
      const href = el.getAttribute('href');
      if (href === '#' || href === '') return; // placeholder / skip links
      this.close();
    });

    this.setupFocusTrapLinks();
    this.onDocClickBound = (e) => this.onDocClick(e);

    // Animate the drawer's height when a panel switch changes the content height
    // (different number of rows), like the desktop flyout resizes. A ResizeObserver
    // on the inner catches every switch; we FLIP its height old→new and keep the
    // frost backdrop synced during the tween. AAS-1169
    this.innerEl = this.querySelector('.nav-drawer__inner');
    this._lastInnerH = 0;
    this._resizeAnimating = false;
    this._resizeDone = null;      // pending tween finisher (run-once, cancellable)
    this._resizeDoneTimer = null; // its safety-net timeout
    this._resizeEndListener = null;
    this._closeTimer = null;      // close-finish cleanup; cancelled by a reopen (AAS-1169)
    if (window.ResizeObserver && this.innerEl) {
      this._ro = new ResizeObserver(() => this.onInnerResize());
      this._ro.observe(this.innerEl);
    }

    // Resizing into desktop while open: the burger hides at ≥1024px but the
    // drawer has no desktop styles, so it would stay glued over the desktop nav
    // with the body scroll still locked. Close through the normal path — focus
    // trap, aria-expanded, scroll lock and the frost backdrop (drawer-closing)
    // all unwind together. close() no-ops when already closed. AAS-1169
    navDesktopMQ.addEventListener('change', (e) => {
      if (e.matches) this.close();
    });
  }

  onInnerResize() {
    if (!this.isOpen || this._resizeAnimating) return;
    const to = this.innerEl.offsetHeight;
    const from = this._lastInnerH;
    this._lastInnerH = to;
    if (!from || Math.abs(from - to) < 1) return; // first fill or no change
    if (navReduceMotionMQ.matches) return;

    this._resizeAnimating = true;
    this.classList.add('is-resizing'); // clip overflow so no scrollbar flashes mid-tween
    const ease = (getComputedStyle(this).getPropertyValue('--nav-drawer-ease').trim()) || 'ease';
    const dur = 400;
    this.innerEl.style.transition = 'none';
    this.innerEl.style.height = from + 'px';
    this.innerEl.getBoundingClientRect(); // reflow to lock the start height
    this.innerEl.style.transition = `height ${dur}ms ${ease}`;
    this.innerEl.style.height = to + 'px';

    // Keep the frosted backdrop tracking the animating drawer bottom each frame.
    const startTs = performance.now();
    const tick = () => {
      this.dispatchEvent(new CustomEvent('drawer-height-changed'));
      if (this._resizeAnimating && performance.now() - startTs < dur + 60) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);

    // Run-once finisher, cancellable from close(): transitionend AND the safety
    // timeout both point here, so without the guard it ran twice — and a timeout
    // surviving close() re-measured a stale height into _lastInnerH (over the 0
    // close() just set), producing a false tween on the next open.
    const done = () => {
      if (this._resizeDone !== done) return; // already ran or cancelled by close()
      this._cancelResizeDone();
      this.innerEl.style.transition = '';
      this.innerEl.style.height = '';
      this.classList.remove('is-resizing');
      this._resizeAnimating = false;
      this._lastInnerH = this.innerEl.offsetHeight;
      this.dispatchEvent(new CustomEvent('drawer-height-changed'));
    };
    // transitionend BUBBLES — a child's own transition ending mid-tween must not
    // finish the height tween early, so filter to the inner's height transition.
    this._resizeDone = done;
    this._resizeEndListener = (e) => {
      if (e.target === this.innerEl && e.propertyName === 'height') done();
    };
    this.innerEl.addEventListener('transitionend', this._resizeEndListener);
    this._resizeDoneTimer = setTimeout(done, dur + 120);
  }

  // Detach the pending tween finisher (listener + timeout). State cleanup stays
  // with the caller: done() finishes the tween, close() resets for the next open.
  _cancelResizeDone() {
    this._resizeDone = null;
    if (this._resizeDoneTimer) {
      clearTimeout(this._resizeDoneTimer);
      this._resizeDoneTimer = null;
    }
    if (this._resizeEndListener) {
      this.innerEl.removeEventListener('transitionend', this._resizeEndListener);
      this._resizeEndListener = null;
    }
  }

  get activePanel() {
    return this.querySelector('.nav-drawer__panel.is-active');
  }

  get activePanelId() {
    return this.history[this.history.length - 1];
  }

  open(burgerBtn) {
    if (this.isOpen) return;
    this.isOpen = true;
    this.burgerBtn = burgerBtn;

    // Reopening inside the 400ms close window: the wrapper still carries
    // .drawer-closing, and that rule out-cascades .drawer-open in
    // section-header.css (same specificity, later in the file) — frost
    // transparent + translated up by --drawer-h, i.e. invisible until the
    // stale close timer finally fired and it popped in. Cancel the pending
    // cleanup and clear the closing state now; the panel/history reset that
    // timer would have done happens right below anyway. AAS-1169
    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }
    this.classList.remove('is-closing');
    this.closest('.header-wrapper')?.classList.remove('drawer-closing');

    this.history = ['l1'];
    this.showPanel('l1', false);

    requestAnimationFrame(() => {
      // close() can land between the tap and this frame (double-tap, doc
      // click, desktop-resize auto-close) — adding the open classes then
      // would leave the drawer visually open while isOpen is false, a state
      // no code path ever unwinds. AAS-1169
      if (!this.isOpen) return;
      this.classList.add('is-open');
      this.closest('.header-wrapper')?.classList.add('drawer-open');
      document.body.classList.add('overflow-hidden-tablet');
      window.ScrollLock && ScrollLock.lock('nav-drawer', { maxWidth: 989 });

      if (burgerBtn) burgerBtn.setAttribute('aria-expanded', 'true');
      trapFocus(this, this.activePanel?.querySelector('button, a') || this);

      // Capture phase: the outside tap must be intercepted before it reaches
      // the page underneath the drawer. See onDocClick. AAS-4661
      document.addEventListener('click', this.onDocClickBound, true);
      this.dispatchEvent(new CustomEvent('drawer-height-changed'));
    });
  }

  close() {
    if (!this.isOpen) return;
    this.isOpen = false;

    // Reset the height-animation state so the next open starts fresh (no tween
    // from a stale height, no leftover inline height). Cancel the pending tween
    // finisher FIRST — its late timeout would overwrite _lastInnerH = 0 below
    // with a re-measured stale height (false tween on next open).
    this._cancelResizeDone();
    this._resizeAnimating = false;
    this._lastInnerH = 0;
    this.classList.remove('is-resizing');
    if (this.innerEl) { this.innerEl.style.transition = ''; this.innerEl.style.height = ''; }

    this.classList.remove('is-open');
    this.classList.add('is-closing');
    // Swap drawer-open → drawer-closing (not remove): keeps the frosted bg-layer
    // through the slide-up and lets its height shrink up in sync, instead of the
    // backdrop vanishing instantly. Cleared with is-closing after 400ms. AAS-1169
    const wrapper = this.closest('.header-wrapper');
    wrapper?.classList.remove('drawer-open');
    wrapper?.classList.add('drawer-closing');
    document.body.classList.remove('overflow-hidden-tablet');
    window.ScrollLock && ScrollLock.unlock('nav-drawer');

    if (this.burgerBtn) {
      this.burgerBtn.setAttribute('aria-expanded', 'false');
      removeTrapFocus(this.burgerBtn);
    }

    // Must mirror open()'s capture flag or the listener is never removed.
    document.removeEventListener('click', this.onDocClickBound, true);
    this.dispatchEvent(new CustomEvent('drawer-height-changed'));

    this._closeTimer = setTimeout(() => {
      this._closeTimer = null;
      this.classList.remove('is-closing');
      wrapper?.classList.remove('drawer-closing');
      this.history = ['l1'];
      this.showPanel('l1', false);
      // .drawer-closing held the bg-layer at its OPEN height + notch clip so the
      // whole panel could slide up as one (see syncBgLayer's drawer-closing
      // branch). Now that it's cleared, wake syncBgLayer so its plain-closed
      // branch restores the bg-layer to closedH with no clip — otherwise it
      // stays dh-tall and the progressive-blur masks (which fade toward the top)
      // leave the resting header with no blur up top / around the notch. AAS-1169
      this.dispatchEvent(new CustomEvent('drawer-height-changed'));
    }, 400);
  }

  toggle(burgerBtn) {
    this.isOpen ? this.close() : this.open(burgerBtn);
  }

  navigateTo(panelId) {
    const panel = this.querySelector(`.nav-drawer__panel[data-panel="${panelId}"]`);
    if (!panel) return;

    const trigger = this.querySelector(`[data-open-panel="${panelId}"]`);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    this.history.push(panelId);

    // Forward L1 → L2: the OTHER L1 items fade out while the tapped item flies +
    // scales into the L2 title position; then the panel switches (L2 cascades its
    // own rows in). Everything else swaps directly.
    const active = this.activePanel;
    const fromL1 = active && active.dataset.level === '1';
    const fromL2ToL3 = active && active.dataset.level === '2' && panel.dataset.level === '3';
    const reduceMotion = navReduceMotionMQ.matches;

    if (reduceMotion) {
      this.showPanel(panelId, true);
    } else if (fromL1) {
      this.animateL1ToL2(trigger, panel, panelId);
    } else if (fromL2ToL3) {
      this.hSlide(active, panel, panelId, false);
    } else {
      this.showPanel(panelId, true);
    }
  }

  // Horizontal cross-slide between L2 and L3 (AAS-1169). Forward (L2 → L3): L2
  // slides left off-screen + fades, L3 comes from the right. back=true reverses it
  // (L3 → L2): L3 slides right, L2 comes from the left. The entering panel stays IN
  // FLOW (defines the drawer height); the leaving one is an absolute overlay so it
  // doesn't collapse the height. The title crossfades + the notch resizes for both.
  // CSS in component-nav-drawer.css.
  hSlide(leaving, entering, panelId, back) {
    const hdr = this.sharedHeader;
    const durMs = parseFloat(getComputedStyle(this).getPropertyValue('--l3-slide-dur')) * 1000 || 400;

    // --- Header: crossfade the title text + animate the notch (clip-path) width ---
    // Capture the OLD title (text + box) before updateHeader swaps it.
    const titleEl = hdr && hdr.querySelector('.nav-drawer__panel-title');
    const bar = hdr && hdr.querySelector('.nav-drawer__header-bar');
    const oldText = titleEl ? titleEl.textContent : '';
    const tRect = titleEl ? titleEl.getBoundingClientRect() : null;
    const bRect = bar ? bar.getBoundingClientRect() : null;

    // is-hsliding BEFORE updateHeader so the notch's clip-path transition is armed
    // when --notch-text-half changes (updateHeader) — the trapezoid resizes smoothly.
    this.classList.add('is-hsliding');
    this.classList.toggle('is-hsliding-back', !!back); // reverse the slide directions
    this.updateHeader(entering, false); // new title text + --notch-text-half
    // Publish the header height so the absolute overlay sits below it.
    const h = hdr && !hdr.hidden ? hdr.offsetHeight : 0;
    this.style.setProperty('--nav-panel-top', h + 'px');

    // Crossfade: overlay a clone carrying the OLD title, fade it out while the new
    // title fades in (all synchronous so the new text never flashes first).
    if (titleEl && bar && tRect && bRect && oldText && oldText !== titleEl.textContent) {
      const clone = titleEl.cloneNode(true);
      clone.textContent = oldText; // cloneNode ran AFTER updateHeader, so restore the OLD text
      clone.classList.add('nav-drawer__panel-title--xfade');
      clone.style.left = (tRect.left - bRect.left) + 'px';
      clone.style.top = (tRect.top - bRect.top) + 'px';
      clone.style.width = tRect.width + 'px';
      bar.appendChild(clone);
      // Hide the new title INSTANTLY (kill its default 0.2s opacity transition
      // first) so only the clone's old text shows, then crossfade.
      titleEl.style.transition = 'none';
      titleEl.style.opacity = '0';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          titleEl.style.transition = `opacity ${durMs}ms ease`;
          titleEl.style.opacity = '1';
          clone.style.opacity = '0';
        });
      });
      const rmClone = () => { clone.remove(); titleEl.style.transition = ''; titleEl.style.opacity = ''; };
      clone.addEventListener('transitionend', rmClone, { once: true });
      setTimeout(rmClone, durMs + 200);
    }

    // --- Panels: L3 in flow (defines height), L2 absolute overlay slides out ---
    this.panels.forEach((p) => {
      if (p !== leaving && p !== entering) {
        p.classList.remove('is-active', 'is-entering', 'is-leaving-h', 'is-entering-h');
        p.style.removeProperty('display');
      }
    });
    leaving.classList.remove('is-active', 'is-entering');
    leaving.classList.add('is-leaving-h');
    entering.classList.remove('is-entering');
    entering.classList.add('is-active', 'is-entering-h');
    this.dispatchEvent(new CustomEvent('drawer-height-changed'));

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      this.classList.remove('is-hsliding', 'is-hsliding-back');
      leaving.classList.remove('is-leaving-h');
      entering.classList.remove('is-entering-h');
      this.showPanel(panelId, false); // normalize final state
    };
    entering.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, durMs + 150); // safety net
  }

  // Reverse of the L1 → L2 morph (AAS-1169): the L2 title flies back + scales UP
  // into the tapped L1 item's spot while the L2 content fades out; on landing, L1
  // returns with its rows rising back in (the target row stays solid — ghost
  // handoff). Falls back to a plain swap if measurement fails.
  animateL2ToL1() {
    const l2panel = this.activePanel;
    const hdr = this.sharedHeader;
    const l1panel = this.querySelector('.nav-drawer__panel[data-panel="l1"]');
    const titleEl = hdr && hdr.querySelector('.nav-drawer__panel-title');
    const l2handle = l2panel && l2panel.dataset.panel;
    const targetItem = l2handle ? this.querySelector(`[data-open-panel="${l2handle}"]`) : null;
    const targetLi = targetItem ? targetItem.closest('li') : null;
    const durMs = parseFloat(getComputedStyle(this).getPropertyValue('--l1-morph-dur')) * 1000 || 350;

    let ghost = null;
    if (titleEl && targetItem && l1panel && hdr && l2panel) {
      const first = this.textRect(titleEl);
      // Measure the target L1 item's RESTING box: show L1 alone (header hidden),
      // cascade suppressed (is-measuring), then revert — all in one tick, no paint.
      const wasHidden = hdr.hidden;
      this.classList.add('is-measuring');
      l2panel.classList.remove('is-active');
      l1panel.classList.add('is-active');
      hdr.hidden = true;
      const last = this.textRect(targetItem);
      hdr.hidden = wasHidden;
      l1panel.classList.remove('is-active');
      l2panel.classList.add('is-active');
      this.classList.remove('is-measuring');

      if (first.width && last.width) {
        const ics = getComputedStyle(targetItem);
        ghost = document.createElement('span');
        ghost.className = 'nav-drawer__morph-ghost';
        ghost.textContent = (titleEl.textContent || '').trim();
        // Render in the ITEM's type at the ITEM's resting spot so the END is
        // pixel-identical to the real L1 item (seamless handoff).
        ghost.style.left = last.left + 'px';
        ghost.style.top = last.top + 'px';
        ghost.style.fontFamily = ics.fontFamily;
        ghost.style.fontWeight = ics.fontWeight;
        ghost.style.fontSize = ics.fontSize;
        ghost.style.lineHeight = ics.lineHeight;
        ghost.style.letterSpacing = ics.letterSpacing;
        ghost.style.color = ics.color;
        document.body.appendChild(ghost);
        // Correct for line-height leading: the item's font has line-height 1.4, so
        // the ghost's glyphs sit lower than the measured text top. Measure the
        // ghost's OWN text rect (same method as `last`) and nudge it so the two
        // align exactly — otherwise the item lands a few px off at the handoff.
        const gRect = this.textRect(ghost);
        ghost.style.left = last.left + (last.left - gRect.left) + 'px';
        ghost.style.top = last.top + (last.top - gRect.top) + 'px';
        // Start ON the title (scaled down), settle to the item (reverse FLIP).
        const startScale = first.width / last.width;
        const sdx = first.left - last.left;
        const sdy = first.top - last.top;
        ghost.style.transform = `translate(${sdx}px, ${sdy}px) scale(${startScale})`;
        titleEl.style.transition = 'none';
        titleEl.style.opacity = '0'; // hide the real title; the ghost stands in
        requestAnimationFrame(() => {
          ghost.style.transition = `transform ${durMs}ms var(--nav-drawer-ease, cubic-bezier(0.31, 1, 0.31, 1))`;
          requestAnimationFrame(() => { ghost.style.transform = 'none'; });
        });
      }
    }

    l2panel.classList.add('is-leaving-back'); // fade the L2 content out during the fly
    this.classList.add('is-header-out');      // fade notch + Back + Shop all out from the start

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      l2panel.classList.remove('is-leaving-back');
      this.showPanel('l1', false); // L1 returns; the OTHER main rows rise in
      // Keep the morph-target row SOLID (no rise/fade) — set AFTER showPanel (which
      // wipes stale inline styles) so it wins over the open cascade this frame. It's
      // cleared later by showPanel, while L1 is hidden — so it never re-triggers the
      // rise on-screen (the bug behind the second fade+move).
      if (targetLi) { targetLi.style.animation = 'none'; targetLi.style.opacity = '1'; }
      if (ghost) ghost.remove();   // target row is solid → seamless handoff
      if (titleEl) { titleEl.style.transition = ''; titleEl.style.opacity = ''; }
    };
    if (ghost) {
      ghost.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, durMs + 150); // safety net
    } else {
      setTimeout(finish, durMs);
    }
  }

  // Forward L1 → L2 (AAS-1169): the tapped label FLIPs (translate + scale-down)
  // into the L2 title's resting spot while the other L1 rows fade out; the panel
  // switch fires the instant the label lands, so the real title takes over
  // seamlessly. Falls back to a timed fade+switch if measurement fails.
  animateL1ToL2(trigger, next, panelId) {
    const l1panel = this.activePanel;
    const hdr = this.sharedHeader;
    l1panel.classList.add('is-leaving'); // the OTHER L1 rows fade out

    const morphMs = parseFloat(getComputedStyle(this).getPropertyValue('--l1-morph-dur')) * 1000 || 350;

    // Measure the tapped label (FIRST) and the L2 title's resting spot (LAST). The
    // header is shown only long enough to measure the title, then re-hidden in the
    // SAME tick (no paint → no visible layout shift); it reappears at the switch.
    let ghost = null;
    if (trigger && hdr) {
      const first = this.textRect(trigger);
      const wasHidden = hdr.hidden;
      this.updateHeader(next, false);
      const titleEl = hdr.querySelector('.nav-drawer__panel-title');
      const last = this.textRect(titleEl);
      hdr.hidden = wasHidden;

      if (first.width && last.width) {
        const tcs = getComputedStyle(titleEl);
        // Hide the real tapped item instantly (no fade) — the ghost carries it.
        trigger.style.transition = 'none';
        trigger.style.opacity = '0';

        ghost = document.createElement('span');
        ghost.className = 'nav-drawer__morph-ghost';
        ghost.textContent = (trigger.textContent || '').trim();
        // Render the ghost in the TITLE's exact type at the title's resting spot, so
        // its END state (transform:none) is pixel-identical to the real title — the
        // handoff has no font-metrics jump. (Using the item's heading font instead
        // left the glyphs a few px off from the title at the end.)
        ghost.style.left = last.left + 'px';
        ghost.style.top = last.top + 'px';
        ghost.style.fontFamily = tcs.fontFamily;
        ghost.style.fontWeight = tcs.fontWeight;
        ghost.style.fontSize = tcs.fontSize;
        ghost.style.lineHeight = tcs.lineHeight;
        ghost.style.letterSpacing = tcs.letterSpacing;
        ghost.style.color = tcs.color;

        // Reverse FLIP (transform-origin top-left): START on the tapped item's box
        // (position + width), then settle to transform:none = the title exactly.
        const startScale = first.width / last.width;
        const sdx = first.left - last.left;
        const sdy = first.top - last.top;
        ghost.style.transform = `translate(${sdx}px, ${sdy}px) scale(${startScale})`;
        document.body.appendChild(ghost);

        // Enable the transition only AFTER the start transform is committed (the
        // ghost lives on <body> and can't read --l1-morph-dur, so set it inline),
        // then animate to the title's resting spot.
        requestAnimationFrame(() => {
          ghost.style.transition = `transform ${morphMs}ms var(--nav-drawer-ease, cubic-bezier(0.31, 1, 0.31, 1))`;
          requestAnimationFrame(() => {
            ghost.style.transform = 'none';
          });
        });
      }
    }

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      l1panel.classList.remove('is-leaving');
      this.showPanel(panelId, false); // header + real title appear
      // Fade the header chrome (notch + Back + Shop all) IN. Uses an animation, not
      // a transition, because the header just went display:none→block (transitions
      // don't run across that). Cleared after it finishes.
      this.classList.add('is-header-in');
      setTimeout(() => this.classList.remove('is-header-in'), morphMs + 100);
      // Trigger the L2 row cascade — ONLY on this forward entry (armed after the
      // panel is displayed so the rows are hidden on their first frame → no blink).
      next.classList.add('is-l2-cascade');
      setTimeout(() => next.classList.remove('is-l2-cascade'), 1200);
      if (ghost) ghost.remove();
      if (trigger) { trigger.style.transition = ''; trigger.style.opacity = ''; }
    };

    if (ghost) {
      ghost.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, morphMs + 150); // safety net if transitionend never fires
    } else {
      const leaveMs = parseFloat(getComputedStyle(this).getPropertyValue('--l1-leave-dur')) * 1000 || 250;
      setTimeout(finish, leaveMs); // no ghost — plain timed fade + switch
    }
  }

  // Bounding rect of an element's TEXT (a Range, not its padded box).
  textRect(el) {
    const r = document.createRange();
    r.selectNodeContents(el);
    return r.getBoundingClientRect();
  }

  goBack() {
    if (this.history.length <= 1) {
      this.close();
      return;
    }

    const leaving = this.activePanel; // panel we're leaving (before the pop)
    const closingId = this.history.pop();
    const closingTrigger = this.querySelector(`[data-open-panel="${closingId}"]`);
    if (closingTrigger) closingTrigger.setAttribute('aria-expanded', 'false');

    const targetId = this.activePanelId;
    const target = this.querySelector(`.nav-drawer__panel[data-panel="${targetId}"]`);
    const reduceMotion = navReduceMotionMQ.matches;

    // Reverse of the forward transitions: L3 → L2 mirrors the slide, L2 → L1
    // mirrors the morph.
    if (!reduceMotion && leaving && target && leaving.dataset.level === '3' && target.dataset.level === '2') {
      this.hSlide(leaving, target, targetId, true);
    } else if (!reduceMotion && leaving && target && leaving.dataset.level === '2' && target.dataset.level === '1') {
      this.animateL2ToL1();
    } else {
      this.showPanel(targetId, true);
    }
  }

  showPanel(panelId, animate) {
    const next = this.querySelector(`.nav-drawer__panel[data-panel="${panelId}"]`);
    if (!next) return;

    this.classList.remove('is-hsliding', 'is-hsliding-back', 'is-measuring', 'is-header-out', 'is-header-in');
    // Clear any inline exclusion left on an L1 row by the reverse morph. Done HERE
    // (as L1 is being (de)activated) so the open-cascade re-attaching to it happens
    // while L1 is display:none — never re-triggering navItemRise on-screen.
    this.querySelectorAll('.nav-drawer__menu--l1-main > li[style]').forEach((li) => {
      li.style.animation = '';
      li.style.opacity = '';
    });
    this.panels.forEach((p) => { p.classList.remove('is-active', 'is-entering', 'is-leaving', 'is-leaving-h', 'is-entering-h', 'is-l2-cascade', 'is-leaving-back'); p.style.removeProperty('display'); });
    next.classList.add('is-active');

    if (animate) {
      next.classList.add('is-entering');
      next.addEventListener('animationend', () => { next.classList.remove('is-entering'); }, { once: true });
    }

    this.updateHeader(next, animate);

    if (this.isOpen) {
      const focusTarget = this.sharedHeader && !this.sharedHeader.hidden
        ? this.sharedHeader.querySelector('.nav-drawer__back')
        : next.querySelector('button, a');
      if (focusTarget) {
        setTimeout(() => { focusTarget.focus({ preventScroll: true }); }, animate ? 200 : 0);
      }
      this.dispatchEvent(new CustomEvent('drawer-height-changed'));
    }
  }

  updateHeader(panel, animate) {
    const hdr = this.sharedHeader;
    if (!hdr) return;

    const level = parseInt(panel.dataset.level, 10);

    if (level === 1 || panel.dataset.hideHeader === 'true') {
      hdr.hidden = true;
      return;
    }

    const title = panel.dataset.title || '';
    const url = panel.dataset.url || '#';

    const titleEl = hdr.querySelector('.nav-drawer__panel-title');
    titleEl.textContent = title;

    // "Shop all" points at the panel's parent node (its data-url). When that
    // node has no destination the URL resolves to '#' — don't show a dead link:
    // hide it and drop the href so it's inert and untracked. Mirrors the Liquid
    // rule that renders link-less nav nodes as inert text.
    const shopAll = hdr.querySelector('.nav-drawer__shop-all');
    if (shopAll) {
      if (url && url !== '#') {
        shopAll.href = url;
        shopAll.hidden = false;
      } else {
        shopAll.removeAttribute('href');
        shopAll.hidden = true;
      }
    }

    if (hdr.hidden) {
      hdr.hidden = false;
    }

    // Fit the header-bar notch line to the title: measure the TEXT width (a Range,
    // not the padded box) and publish half of it. CSS adds --notch-margin and the
    // fixed-angle slant run to build the clip-path (replaces the old two-tier SVG
    // switcher). AAS-1169
    const bar = hdr.querySelector('.nav-drawer__header-bar');
    if (bar) {
      const range = document.createRange();
      range.selectNodeContents(titleEl);
      bar.style.setProperty('--notch-text-half', range.getBoundingClientRect().width / 2 + 'px');
    }
  }

  // Registered in CAPTURE phase (see open()) so this runs BEFORE the tapped
  // element gets the event. The drawer is position:absolute with max-height
  // 90dvh and only as tall as its content — on a 844px viewport it covers ~393px,
  // leaving ~450px of live page below it. A tap there used to both dismiss the
  // drawer AND activate whatever sat underneath (product card, hero link), which
  // is the iOS/Android bug in AAS-4661. Dismissing an open overlay is the tap's
  // only job, so swallow it rather than letting it reach the page.
  onDocClick(event) {
    if (!this.isOpen) return;
    if (this.contains(event.target)) return;
    if (this.burgerBtn && this.burgerBtn.contains(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    this.close();
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    if (!this.isOpen) return;

    if (this.history.length > 1) {
      this.goBack();
    } else {
      this.close();
    }
  }

  setupFocusTrapLinks() {
    this.querySelectorAll('.focus-trap-link-close').forEach((link) => {
      link.addEventListener('focus', (e) => {
        e.preventDefault();
        if (this.burgerBtn) this.burgerBtn.focus();
      });
    });
  }
}

customElements.define('nav-drawer', NavDrawer);


class CustomDrawer extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    const content = document.createElement('div');
    while (this.firstChild) {
      content.appendChild(this.firstChild);
    }
    this.shadowRoot.appendChild(content);

    this.overlay = this.shadowRoot.querySelector('.overlay');
    this.drawer = this.shadowRoot.querySelector('.drawer');
    this.closeButton = this.shadowRoot.querySelector('.close-drawer-btn');

    this.overlay.addEventListener('click', () => this.close());
    this.closeButton.addEventListener('click', () => this.close());
  }

  open() {
    this.setAttribute('open', '');
  }

  close() {
    this.removeAttribute('open');
  }

  static get observedAttributes() {
    return ['open'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open' && newValue !== null) {
      this.style.display = 'block';
    } else {
      this.style.display = 'none';
    }
  }
}

customElements.define('custom-drawer', CustomDrawer);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.open-drawer-btn').forEach(button => {
    button.addEventListener('click', () => {
      const targetId = button.getAttribute('data-target');
      const targetDrawer = document.getElementById(targetId);
      if (targetDrawer) {
        targetDrawer.open();
      }
    });
  });
});



class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.handleKeyDown = this.handleKeyDown.bind(this);
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    /* Added on EVERY (re)connect: a dialog may be hoisted to <body> after the
     * initial parse (other-features.js escapes its section's stacking
     * context) — the move disconnects the node, and a once-only guard here
     * would strip the Escape-to-close hook for good. addEventListener
     * dedupes the same bound reference, so a plain connect stays single. */
    document.addEventListener('keydown', this.handleKeyDown);
  }
  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown(event) {
    if (event.key === 'Escape' && this.hasAttribute('open')) {
      this.hide();
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    window.ScrollLock && ScrollLock.lock('modal-dialog');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
  
    // Trap focus within the modal dialog
    setTimeout(() => {
      const firstFocusableElement = this.querySelector('a, input, button, [tabindex]:not([tabindex="-1"])');
      trapFocus(this, firstFocusableElement);
    },300);
    
  }
  

  hide() {
    this.setAttribute("closing", "true"),
    setTimeout(() => {
    document.body.classList.remove('overflow-hidden');
    window.ScrollLock && ScrollLock.unlock('modal-dialog');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    this.removeAttribute("closing");
    removeTrapFocus(this.openedBy);
    },300);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/* AAS-5067: merged sold-out CTA — the buy-box submit button doubles as the
 * back-in-stock opener when the shown variant is sold out (data-notify-modal
 * is set server-side in buy-buttons.liquid and kept in sync across variant
 * swaps by toggleAddButton). Delegated because those swaps rewrite the
 * button's attributes in place — a direct listener could be bound to a state
 * the button no longer represents. */
document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-notify-modal]');
  if (!opener) return;
  const modal = document.querySelector(opener.dataset.notifyModal);
  if (!modal) return;
  if (typeof modal.open === 'function') modal.open(opener); // info-drawer (unified base, AAS-5067)
  else if (typeof modal.show === 'function') modal.show(opener); // legacy modal-dialog
});

/* The back-in-stock drawer used to carry its own per-option dropdowns and a
 * delegated change handler that resolved the picked combination against an
 * embedded variants JSON. Both are gone: the drawer confirms the PDP's
 * selection and nothing else, so updateSoldOutState is the only writer of its
 * hidden variant/sku/GID inputs. */

/* AAS-5067: label fit for the merged CTA. "Sold out - Notify me" can outgrow
 * one line in longer locales, especially in the mobile floating bar — when it
 * does, the label falls back to the short "Notify me" alone. Both labels ship
 * as data attributes (buy-buttons.liquid) so translations ride along. The
 * measurement always starts from the full label under a forced nowrap: on
 * desktop (≥1025px) the label is the abs-positioned max-content span whose
 * max-width caps it, so its scrollWidth > clientWidth flags the overflow;
 * below that the label is a flex item that grows WITH its content (its own
 * scroll metrics never disagree), so the overflow is only visible on the
 * BUTTON box — same button-level check initAtcPlusFit (mobile-option-
 * sheets.js) uses for the neighbouring "+"-icon fit. */
function fitNotifyLabels(root = document) {
  root.querySelectorAll('[data-notify-modal][data-notify-label-full]').forEach((button) => {
    const label = button.querySelector(
      'span:not(.product-form__submit-plus):not(.buttonPrice):not(.product-form__submit-pricebar)'
    );
    const full = button.dataset.notifyLabelFull;
    const short = button.dataset.notifyLabelShort;
    if (!label || !full || !short) return;

    label.textContent = full;
    const prevWhiteSpace = label.style.whiteSpace;
    label.style.whiteSpace = 'nowrap';
    const overflows = window.matchMedia('(min-width: 1025px)').matches
      ? label.scrollWidth > label.clientWidth + 1
      : button.scrollWidth > button.clientWidth + 1;
    label.style.whiteSpace = prevWhiteSpace;
    if (overflows) label.textContent = short;
  });
}

(() => {
  let notifyFitFrame = null;
  window.addEventListener(
    'resize',
    () => {
      if (notifyFitFrame) return;
      notifyFitFrame = requestAnimationFrame(() => {
        notifyFitFrame = null;
        fitNotifyLabels();
      });
    },
    { passive: true }
  );
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fitNotifyLabels());
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fitNotifyLabels());
  } else {
    fitNotifyLabels();
  }
})();


// --- API Loading Functions (loadYouTubeApi, loadVimeoApi) remain the same ---

let onYouTubeApiReadyPromise = null;
function loadYouTubeApi() {
  if (!onYouTubeApiReadyPromise) {
    onYouTubeApiReadyPromise = new Promise((resolve) => {
      if (window.YT && window.YT.Player) {
        resolve();
        return;
      }
      const existingCallback = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        if (existingCallback) {
          existingCallback();
        }
        resolve();
      };
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);
      }
    });
  }
  return onYouTubeApiReadyPromise;
}

let vimeoApiPromise = null;
function loadVimeoApi() {
  if (!vimeoApiPromise) {
    vimeoApiPromise = new Promise((resolve) => {
      if (window.Vimeo && window.Vimeo.Player) {
        resolve();
        return;
      }
       if (!document.querySelector('script[src="https://player.vimeo.com/api/player.js"]')) {
          const tag = document.createElement('script');
          tag.src = "https://player.vimeo.com/api/player.js";
          tag.onload = resolve;
          document.head.appendChild(tag);
       } else {
         const checkVimeo = setInterval(() => {
            if (window.Vimeo && window.Vimeo.Player) {
               clearInterval(checkVimeo);
               resolve();
            }
         }, 100);
       }
    });
  }
  return vimeoApiPromise;
}


class DeferredMedia extends HTMLElement {
  static get observedAttributes() {
    return ['playing'];
  }

  constructor() {
    super();
    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    this.template = this.querySelector('template');
    this.mediaElement = null;
    this.playerController = null;
    this.mediaKind = null;
    this.boundActivate = this.activate.bind(this);
    this.visibilityObserver = null;
    this.playPauseButton = null;
    this.boundHandlePlayPauseClick = this._handlePlayPauseClick.bind(this);

    if (!this.poster || !this.template) { return; }
    this.poster.addEventListener('click', this.boundActivate);
  }

  connectedCallback() {
    if (this.hasAttribute('autoplay')) {
      this._initiateAutoplayObserver();
    }
  }

  disconnectedCallback() {
    if (this.poster) {
      this.poster.removeEventListener('click', this.boundActivate);
    }
    if (this.visibilityObserver) {
      this.visibilityObserver.disconnect();
      this.visibilityObserver = null;
    }
    if (this.playPauseButton) {
       this.playPauseButton.removeEventListener('click', this.boundHandlePlayPauseClick);
       this.playPauseButton = null;
    }
    this.removeAttribute('has-play-pause-button');

    if (this.playerController && typeof this.playerController.destroy === 'function') {
       try { this.playerController.destroy(); } catch(e) {}
    } else if (this.mediaKind === 'video' && this.mediaElement) {
        this.mediaElement.pause();
    } else if (this.mediaKind === 'model' && this.playerController && typeof this.playerController.pause === 'function') {
        try { this.playerController.pause(); } catch(e) {}
    }
    this._detachStateListeners();
    this.playerController = null;
    this.mediaElement = null;
  }

  activate() {
    if (this.hasAttribute('playing')) return;

    if (!this.getAttribute('loaded')) {
      this._initializeMedia().then(loaded => {
        if (loaded) {
          this._initiatePlayback();
        }
      }).catch(error => {
         console.error("DeferredMedia: Error initializing media:", error);
      });
    } else {
      this._initiatePlayback();
    }
  }

  pause() {
    if (!this.hasAttribute('playing') || (!this.mediaElement && !this.playerController)) return;

    if (this.playerController) {
      if (this.mediaKind === 'youtube' && typeof this.playerController.pauseVideo === 'function') {
        this.playerController.pauseVideo();
      } else if (this.mediaKind === 'vimeo' && typeof this.playerController.pause === 'function') {
        this.playerController.pause();
      } else if (this.mediaKind === 'model' && typeof this.playerController.pause === 'function') {
        try { this.playerController.pause(); } catch(e) {}
      }
    } else if (this.mediaKind === 'video' && this.mediaElement) {
      this.mediaElement.pause();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'playing' && this.hasAttribute('loaded')) {
      this._updatePlayPauseButtonState(newValue !== null);
      if (newValue !== null) {
        this.dispatchEvent(new CustomEvent("media:play", { bubbles: true, detail: this }));
        const group = this.getAttribute('group');
        if (group) {
          document.querySelectorAll(`deferred-media[group="${group}"], product-model[group="${group}"]`).forEach(item => {
            if (item !== this && typeof item.pause === 'function') {
              item.pause();
            }
          });
        }
      } else {
        this.dispatchEvent(new CustomEvent("media:pause", { bubbles: true, detail: this }));
      }
    }
  }

  _initiatePlayback() {
     if (!this.mediaElement && !this.playerController) {
       return;
     }

     if (this.playerController) {
        if (this.mediaKind === 'youtube' && typeof this.playerController.playVideo === 'function') {
          this.playerController.playVideo();
        } else if (this.mediaKind === 'vimeo' && typeof this.playerController.play === 'function') {
          this.playerController.play().catch(error => console.error("Vimeo play error:", error));
        } else if (this.mediaKind === 'model' && typeof this.playerController.play === 'function') {
           try { this.playerController.play(); } catch(e) {}
        }
     } else if (this.mediaKind === 'video' && this.mediaElement) {
        const playPromise = this.mediaElement.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            if (error.name === "NotAllowedError") { this.mediaElement.controls = true; }
          });
        }
     }
  }

  async _initializeMedia(focus = false) {
    if (this.getAttribute('loaded')) return true;
    if (!this.template || !this.template.content || !this.template.content.firstElementChild) return false;

    const container = document.createElement('div');
    const elementContent = this.template.content.cloneNode(true);
    container.appendChild(elementContent);

    const mediaNode = container.querySelector('video, iframe, model-viewer');
    const playPauseButtonNode = container.querySelector('.deferred-media-control__play-pause');

    if (!mediaNode) return false;

    this.mediaElement = mediaNode;
    this.appendChild(this.mediaElement);
    this.setAttribute('loaded', true);

    if (playPauseButtonNode) {
        this.appendChild(playPauseButtonNode);
        this.playPauseButton = playPauseButtonNode;
        if (this.hasAttribute('autoplay')) {
            this.playPauseButton.addEventListener('click', this.boundHandlePlayPauseClick);
            this.setAttribute('has-play-pause-button', '');
            this._updatePlayPauseButtonState(true);
        }
    }

    const nodeName = this.mediaElement.nodeName;

    if (nodeName === 'VIDEO') {
        this.mediaKind = 'video';
        this._attachStateListeners();
    } else if (nodeName === 'IFRAME') {
        const source = this.mediaElement.getAttribute('src') || '';
        if (source.includes('youtube.com') || source.includes('youtu.be')) {
            this.mediaKind = 'youtube';
            if (!this.mediaElement.id) {
                this.mediaElement.id = `deferred-yt-${Date.now()}-${Math.random().toString(36).substring(2, 7)}`;
            }
            try {
                await loadYouTubeApi();
                this.playerController = new YT.Player(this.mediaElement.id, {
                    events: { 'onStateChange': this._handleYouTubeStateChange.bind(this) }
                });
            } catch(error) {
                console.error("YouTube Player init error:", error);
                this.removeAttribute('loaded'); this.removeChild(this.mediaElement); return false;
            }
        } else if (source.includes('vimeo.com')) {
            this.mediaKind = 'vimeo';
             try {
                 await loadVimeoApi();
                 this.playerController = new Vimeo.Player(this.mediaElement);
                 this._attachVimeoListeners();
             } catch(error) {
                 console.error("Vimeo Player init error:", error);
                 this.removeAttribute('loaded'); this.removeChild(this.mediaElement); return false;
             }
        } else {
            this.mediaKind = 'iframe_unknown';
        }
    } else if (nodeName === 'MODEL-VIEWER') {
        this.mediaKind = 'model';
    } else {
         this.mediaKind = 'unknown';
         this.removeAttribute('loaded'); this.removeChild(this.mediaElement); return false;
    }

    if(this.poster) {
        this.poster.style.display = 'none';
        this.poster.removeEventListener('click', this.boundActivate);
    }

    if (focus && this.mediaElement && typeof this.mediaElement.focus === 'function') {
        try { this.mediaElement.focus(); } catch (e) {}
    }

    return true;
  }

  _attachStateListeners() {
      if (!this.mediaElement || this.mediaKind !== 'video') return;
      this._detachStateListeners();
      this._stateListeners = {
          play: () => this.setAttribute('playing', ''),
          pause: () => this.removeAttribute('playing'),
          ended: () => this.removeAttribute('playing')
      };
      this.mediaElement.addEventListener('play', this._stateListeners.play);
      this.mediaElement.addEventListener('pause', this._stateListeners.pause);
      this.mediaElement.addEventListener('ended', this._stateListeners.ended);
  }

  _handleYouTubeStateChange(event) {
      if (event.data === YT.PlayerState.PLAYING) {
          this.setAttribute('playing', '');
      } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.BUFFERING) {
          this.removeAttribute('playing');
      }
  }

  _attachVimeoListeners() {
      if(!this.playerController || this.mediaKind !== 'vimeo') return;
      this._detachStateListeners();
      this._stateListeners = {
          play: () => this.setAttribute('playing', ''),
          pause: () => this.removeAttribute('playing'),
          ended: () => this.removeAttribute('playing')
      };
      this.playerController.on('play', this._stateListeners.play);
      this.playerController.on('pause', this._stateListeners.pause);
      this.playerController.on('ended', this._stateListeners.ended);
  }

  _detachStateListeners() {
      const listeners = this._stateListeners;
      if (this.mediaElement && this.mediaKind === 'video' && listeners) {
          this.mediaElement.removeEventListener('play', listeners.play);
          this.mediaElement.removeEventListener('pause', listeners.pause);
          this.mediaElement.removeEventListener('ended', listeners.ended);
      }
      else if (this.playerController && this.mediaKind === 'vimeo' && listeners) {
          try {
              this.playerController.off('play', listeners.play);
              this.playerController.off('pause', listeners.pause);
              this.playerController.off('ended', listeners.ended);
          } catch(e) {}
      }
      else if (this.mediaElement && this.mediaKind === 'model' && listeners) {
           try {
               this.mediaElement.removeEventListener('shopify_model_viewer_ui_toggle_play', listeners.play);
               this.mediaElement.removeEventListener('shopify_model_viewer_ui_toggle_pause', listeners.pause);
           } catch(e) {}
      }
      this._stateListeners = null;
  }

  _initiateAutoplayObserver() {
    if (this.visibilityObserver || !('IntersectionObserver' in window)) {
      return;
    }
    const observerOptions = { root: null, rootMargin: '0px', threshold: 0.1 };
    this.visibilityObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasAttribute('playing') && !this.getAttribute('loaded')) {
          this.activate();
          observer.disconnect();
          this.visibilityObserver = null;
        }
      });
    }, observerOptions);
    this.visibilityObserver.observe(this);
  }

  _handlePlayPauseClick() {
    if (this.hasAttribute('playing')) {
      this.pause();
    } else {
      this.activate();
    }
  }

  _updatePlayPauseButtonState(isPlaying) {
    if (!this.playPauseButton) return;
    if (isPlaying) {
      this.playPauseButton.classList.remove('is-paused');
      this.playPauseButton.classList.add('is-playing');
      this.playPauseButton.setAttribute('aria-label', 'Pause');
    } else {
      this.playPauseButton.classList.remove('is-playing');
      this.playPauseButton.classList.add('is-paused');
      this.playPauseButton.setAttribute('aria-label', 'Play');
    }
  }
}

customElements.define('deferred-media', DeferredMedia);




class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }
  connectedCallback() {
    this.getVariantData();
    /* AAS-4992: warm the section HTML for the colour/size the pointer is about
     * to land on. `pointerover` bubbles (pointerenter does not) and also fires
     * on the first touch, so this covers mouse and touch alike. */
    this.addEventListener('pointerover', this.onVariantPrefetchHint);
    this.addEventListener('focusin', this.onVariantPrefetchHint);
    this.addEventListener('pointerout', this.cancelVariantPrefetchHint);
  }
  onVariantChange(event) {
    this.syncMobileDesktopSelections(event);
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.toggleStickyAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateMobileSheetAvailability();
    this.updateVariantText();
    this.updateSoldOutState();
    this.updateButtonPrice(); 
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.toggleStickyAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateCarousel();
      
    }
  }

  updateCarousel() {
    const getFallbackMediaId = (element) => {
      // When the variant has no featured_media, fall back to the first slide
      // in the gallery (i.e. the product's default image) so the gallery
      // doesn't remain "stuck" on a previously selected variant's image.
      if (!element) return null;
      const firstSlide = element.querySelector('.splide__track .splide__slide[data-media-id]');
      return firstSlide ? firstSlide.getAttribute('data-media-id') : null;
    };
    const updateCarouselForElement = (element) => {
      if (!element) return;
      let mediaId = this.currentVariant && this.currentVariant.featured_media
        ? this.currentVariant.featured_media.id
        : getFallbackMediaId(element);
      if (mediaId != null) {
        element.updateCarouselImages(mediaId);
      }
    };
    const galleryCarousel = document.getElementById(`Gallery-carousel-${this.dataset.section}`);
    updateCarouselForElement(galleryCarousel);
    const quickViewContainer = document.querySelector('.product-modal-content');
    if (quickViewContainer) {
      const galleryCarouselQuickView = quickViewContainer.querySelector(`#Gallery-carousel-${this.dataset.section}`);
      updateCarouselForElement(galleryCarouselQuickView);
    }
  }
  
  /* Which of the two pickers is LIVE is a CSS decision, and the breakpoint is not
   * one number: the PDP's floating actions row swaps to the mobile pickers at
   * <=1024px (.product__actions-row rules in section-main-product.css), while a
   * picker rendered outside that row — quick view, compare — swaps at <=749px
   * (component-product-variant-picker.css). A hardcoded width here disagreed with
   * the CSS across 750–1024px: the shopper picked a size in the mobile sheet, this
   * read the stale desktop radios instead, and the hidden id input — hence what
   * add-to-cart posted — stayed on the previously rendered variant. Ask the DOM
   * which picker is actually painted so JS and CSS cannot drift again. */
  _isMobilePickerLive() {
    const isRendered = (el) =>
      !!el && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

    if (isRendered(this.querySelector('.variant-picker--mobile'))) return true;
    if (isRendered(this.querySelector('.variant-picker--desktop'))) return false;
    // Nothing measurable — a display:none ancestor, e.g. a quick view that has not
    // been opened yet. Fall back to the component stylesheet's own breakpoint.
    return window.innerWidth < 750;
  }

  _getResponsiveSkipClass() {
    return this._isMobilePickerLive() ? 'variant-picker--desktop' : 'variant-picker--mobile';
  }

  _getVisibleInputWrappers() {
    const skipClass = this._getResponsiveSkipClass();
    return [...this.querySelectorAll('.product-form__input')].filter(el => !el.classList.contains(skipClass));
  }

  syncMobileDesktopSelections(event) {
    const target = event.target;
    if (!target) return;
    const optionName = target.name || target.getAttribute('name');
    if (!optionName) return;
    const value = target.value;
    /* Direction follows the control that fired, not the viewport: the mobile sheet,
     * the desktop swatches and the sticky bar all reach this through a bubbling
     * `change`, and only the target knows which picker it came from. Deciding by
     * width left the other picker stale whenever the two disagreed. */
    const isMobile = !!(target.closest && target.closest('.variant-picker--mobile'));

    // Map between select names "options[Color]" and radio names "Color"
    const radioName = optionName.replace(/^options\[(.+)\]$/, '$1');
    const selectName = optionName.includes('options[') ? optionName : `options[${optionName}]`;

    if (isMobile) {
      // User changed mobile dropdown — sync to desktop radio buttons
      this.querySelectorAll('.variant-picker--desktop').forEach(wrapper => {
        const matchingRadio = wrapper.querySelector(`input[name="${radioName}"][value="${CSS.escape(value)}"]`);
        if (matchingRadio) matchingRadio.checked = true;
      });
      // Update mobile color swatch if this is a color option
      this.updateMobileColorSwatch(radioName, selectName, value);
    } else {
      // User changed desktop radio — sync to mobile dropdowns
      this.querySelectorAll(`.variant-picker--mobile select[name="${selectName}"]`).forEach(sel => {
        sel.value = value;
      });
      // Also update mobile color swatch to stay in sync
      this.updateMobileColorSwatch(radioName, selectName, value);
    }

    const desktopColorFieldset = this.querySelector('.product-form__input--color.variant-picker--desktop');
    if (desktopColorFieldset) {
      const isColorOption = !!desktopColorFieldset.querySelector(`input[name="${radioName}"]`);
      if (isColorOption) {
        const labelValue = desktopColorFieldset.querySelector('.form__label-value');
        // Show the native Shopify option value (e.g. "Black") so casing matches the
        // Variants editor. The PIM name (data-pim-color) is no longer used — it came
        // through ALL CAPS from Salsify.
        if (labelValue) labelValue.textContent = value;
      }
    }
  }

  updateMobileColorSwatch(radioName, selectName, value) {
    // Find the desktop color fieldset to read swatch colors from
    const colorFieldset = this.querySelector('.product-form__input--color.variant-picker--desktop');
    if (!colorFieldset) return;
    // Check if this option is the color option by looking for radios with matching name
    const colorRadio = colorFieldset.querySelector(`input[name="${radioName}"]`);
    if (!colorRadio) return;
    // Find the matching desktop swatch label for the selected value
    const matchingRadio = colorFieldset.querySelector(`input[name="${radioName}"][value="${CSS.escape(value)}"]`);
    if (!matchingRadio) return;
    const swatchLabel = colorFieldset.querySelector(`label[for="${matchingRadio.id}"]`);
    if (!swatchLabel) return;
    // Read the swatch color from the desktop label's CSS variable
    const swatchColor = swatchLabel.style.getPropertyValue('--swatch-color');
    // Update the mobile color dropdown's swatch
    const mobileColorWrapper = this.querySelector(`.variant-picker--mobile select[name="${selectName}"]`)
      ?.closest('.variant-picker--mobile');
    if (mobileColorWrapper) {
      const mobileSwatch = mobileColorWrapper.querySelector('.actions-row-swatch');
      if (mobileSwatch && swatchColor) {
        mobileSwatch.style.backgroundColor = swatchColor;
      }
      const labelSwatch = mobileColorWrapper.querySelector('.form__label-swatch');
      if (labelSwatch && swatchColor) {
        labelSwatch.style.backgroundColor = swatchColor;
      }
      const labelValue = mobileColorWrapper.querySelector('.form__label-value--color');
      if (labelValue) {
        const swatchEl = labelValue.querySelector('.form__label-swatch');
        const swatchHtml = swatchEl ? swatchEl.outerHTML : '';
        // Show the native Shopify option value (e.g. "Black") so casing matches the
        // Variants editor. The PIM name (data-pim-color) is no longer used — it came
        // through ALL CAPS from Salsify.
        const displayName = value;
        labelValue.innerHTML = swatchHtml + ' ' + displayName;
      }
    }
  }

  // Option groups (select / fieldset) that belong to the current breakpoint —
  // the mobile and desktop pickers are both in the DOM, only one is live.
  _getVisibleOptionGroups() {
    const skipClass = this._getResponsiveSkipClass();
    return Array.from(this.querySelectorAll('select, fieldset')).filter((el) => !el.closest('.' + skipClass));
  }

  _readVisibleOptionValues() {
    return this._getVisibleOptionGroups().map((element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateOptions() {
    this.options = this._readVisibleOptionValues();
  }
  updateVariantText() {}
  
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }


  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton ) return;
    shareButton.setAttribute('data-url', `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      /* buy-buttons.liquid renders this input `disabled` for a sold-out variant,
       * and only the value was being synced here — so a PDP first rendered on a
       * sold-out variant kept a disabled id input for the rest of the visit, and
       * once the shopper picked an in-stock size the re-enabled add-to-cart
       * button POSTed no variant at all. */
      input.disabled = this.currentVariant.available === false;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    /* Option 1 has to come from the live picker, same as the wrappers below.
     * `:checked` returns the first match in DOM order — always a desktop radio,
     * even when the mobile pickers are the ones on screen. */
    const selectedOptionOne =
      (this.options && this.options[0]) || this.querySelector(':checked')?.value;
    if (selectedOptionOne == null) return;
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => selectedOptionOne === variant.option1
    );
    const inputWrappers = this._getVisibleInputWrappers();
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    // AAS-4164 catalog-only market — every option reads as available on the
    // catalog market: no `disabled` styling and no "Unavailable - [value]" text
    // rewrite. Stock is hidden everywhere else, and with no price and no
    // add-to-cart a greyed-out option is a dead control that just looks broken.
    const catalogMarket = document.documentElement.classList.contains('market--catalog');

    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = catalogMarket || availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
        element.classList.toggle('disabled', !availableElement); 
      }
    });
  }

  /* AAS-5053: the mobile bottom sheets (assets/mobile-option-sheets.js) render a
   * button grid that lives OUTSIDE of `_getVisibleInputWrappers()` — they are
   * neither the desktop radios/dropdowns nor the hidden mobile <select> that
   * updateVariantStatuses() targets, so that method never touched them and a
   * size sold out in the selected colour still showed as tappable on mobile.
   * This mirrors the same combination-aware algorithm (product-variant-options
   * .liquid / product-variant-options-color.liquid) directly off live variant
   * JSON, keyed by the option's position (data-option-position, set in
   * snippets/product-variant-picker.liquid) rather than by breakpoint, so it
   * keeps every sheet in sync regardless of which picker is currently live. */
  updateMobileSheetAvailability() {
    // AAS-5053 follow-up: assets/mobile-option-sheets.js teleports every
    // `.mobile-option-sheet` out of <variant-selects> into `.product__actions-row`
    // on load (comment there: "avoid containing-block issues"), so it is a SIBLING
    // of this custom element, not a descendant, by the time any variant change
    // fires. `this.querySelectorAll(...)` silently matched nothing here — the
    // `if (!sheets.length) return` never logged, it just made the whole function a
    // no-op after the very first paint. That is why is-unavailable (strikethrough)
    // only ever reflected the SSR default and never updated after a colour/size
    // change. Query `document` instead — the sheets are still unique DOM nodes,
    // just relocated.
    const sheets = document.querySelectorAll('.mobile-option-sheet[data-option-position]');
    if (!sheets.length) return;
    const variants = this.getVariantData();
    const catalogMarket = document.documentElement.classList.contains('market--catalog');
    const selectedOptions = this.options || [];

    sheets.forEach((sheet) => {
      const position = parseInt(sheet.dataset.optionPosition, 10);
      if (!position) return;
      // AAS-5053 follow-up: also re-derive is-selected here, from the same
      // authoritative `selectedOptions` this function already uses for
      // availability, instead of leaving it to whichever other listener last
      // touched this button. The sheet's own click handler and the
      // document-level 'change' listener in mobile-option-sheets.js keep it in
      // sync for direct interaction, but this is the one place guaranteed to
      // run on every resolved variant change and re-assert the truth — closing
      // the gap that let the "Velikosti" sheet highlight a stale size after a
      // colour switch left the size untouched.
      const selectedValue = selectedOptions[position - 1];
      let selectedValueUnavailable = false;
      sheet.querySelectorAll('[data-sheet-option-value]').forEach((btn) => {
        const value = btn.dataset.sheetOptionValue;
        const available =
          catalogMarket ||
          variants.some((variant) => {
            if (variant[`option${position}`] !== value || !variant.available) return false;
            for (let i = 1; i < position; i += 1) {
              if (variant[`option${i}`] !== selectedOptions[i - 1]) return false;
            }
            return true;
          });
        // AAS-5053 follow-up: visual-only, like the desktop swatch picker
        // (product-variant-options.liquid uses a CSS class, never the
        // `disabled` attribute) — selecting a sold-out combination has to
        // stay possible so the CTA can report "Sold out" / "Notify me" the
        // same way on mobile and desktop.
        btn.classList.toggle('is-unavailable', !available);
        if (selectedValue !== undefined) {
          btn.classList.toggle('is-selected', value === selectedValue);
          if (value === selectedValue) selectedValueUnavailable = !available;
        }
      });

      // AAS-5053 follow-up: the collapsed trigger cell (the "Velikost X" bar
      // that opens this sheet) showed the value as plain text with no
      // unavailable signal at all — desktop strikes the equivalent selected
      // pill (see the SSR `sel_value_unavailable` in product-variant-picker
      // .liquid). Reuse `selectedValueUnavailable` from the loop above —
      // it's the SAME per-position, backward-only "is THIS option's own
      // value disabled" check the desktop swatch picker uses
      // (product-variant-options.liquid `option_disabled`), not
      // `this.currentVariant.available` (the whole resolved combo). Using
      // the combo-wide flag here struck the COLOUR trigger too whenever the
      // selected SIZE alone was sold out for that colour — colour is
      // position 1 so its own availability never depends on size to begin
      // with, exactly like the desktop colour swatch never gets struck in
      // that situation. Matched to its trigger by the same handleized name
      // both elements already carry.
      const sheetName = sheet.dataset.mobileSheet;
      const trigger = sheetName ? document.querySelector(`[data-mobile-sheet-trigger="${sheetName}"]`) : null;
      const labelValue = trigger && trigger.querySelector('.form__label-value');
      if (labelValue) {
        labelValue.classList.toggle('is-unavailable', selectedValueUnavailable);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
   
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  // AAS-5067: the back-in-stock drawer's product summary is server-rendered and
  // swapped per variant in renderProductInfo. What lives outside that swap is
  // the drawer's variant identity — three hidden inputs in the email form,
  // whose typed input must survive — so mirror the PDP pick into them here.
  // This is their only writer: the drawer is read-only, so nothing else can
  // disagree about what is being signed up for. Title labels the pick; sku +
  // GID are what the middleware signup posts (back-in-stock-form.js).
  updateSoldOutState() {
    if (!this.currentVariant) return;
    const section = this.dataset.section;
    const variantInput = document.getElementById(`ContactFormSoldout-variant-${section}`);
    if (variantInput) variantInput.value = this.currentVariant.title;
    const skuInput = document.getElementById(`BackInStockSku-${section}`);
    if (skuInput) skuInput.value = this.currentVariant.sku || '';
    const variantIdInput = document.getElementById(`BackInStockVariantId-${section}`);
    if (variantIdInput) variantIdInput.value = `gid://shopify/ProductVariant/${this.currentVariant.id}`;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }
  /* AAS-4992 — variant section prefetch.
   * The delay a shopper feels on a swatch click is the section render plus the
   * Aprimo CDN fetch for the new gallery, and neither starts until the click.
   * Warming the section HTML while the pointer is still travelling means the
   * click usually finds the markup already in hand, and the browser has had a
   * head start on the <img srcset> inside it. One small HTML response per
   * hovered swatch, deduped and capped; skipped on metered/slow connections. */
  variantSectionUrl(variantId) {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    return `${this.dataset.url}?variant=${variantId}&section_id=${sectionId}`;
  }

  onVariantPrefetchHint(event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    // The pointer has to settle before we spend a request — sweeping across a
    // 10-swatch row must not fire 10 section renders.
    this.cancelVariantPrefetchHint();
    this.variantPrefetchTimer = setTimeout(() => {
      const variantId = this.resolveHintedVariantId(target);
      if (variantId) this.prefetchVariantSection(variantId);
    }, 120);
  }

  cancelVariantPrefetchHint() {
    if (this.variantPrefetchTimer) {
      clearTimeout(this.variantPrefetchTimer);
      this.variantPrefetchTimer = null;
    }
  }

  // Which variant would selecting the hovered control produce? Current
  // selections with that one option value substituted.
  resolveHintedVariantId(target) {
    let control = target.closest('input[type="radio"], select, option, label[for]');
    if (!control) return null;
    if (control.tagName === 'LABEL') control = document.getElementById(control.htmlFor);
    if (!control) return null;

    const groups = this._getVisibleOptionGroups();
    // Hovering the picker for the other breakpoint (both are in the DOM) — the
    // value doesn't map onto the live option order, so don't guess.
    const index = groups.findIndex((group) => group.contains(control));
    if (index < 0) return null;

    const current = this._readVisibleOptionValues();
    const candidate = current.slice();
    candidate[index] = control.value;
    // Hovering the option that is already selected (or a <select>, whose .value
    // is the current pick) tells us nothing — don't spend a request on it. Also
    // covers the pre-first-change state, where currentVariant isn't set yet.
    if (candidate.every((value, i) => value === current[i])) return null;

    const variant = this.getVariantData().find(
      (v) => !v.options.map((option, i) => candidate[i] === option).includes(false)
    );
    if (!variant) return null;
    if (this.currentVariant && this.currentVariant.id === variant.id) return null;
    return variant.id;
  }

  prefetchVariantSection(variantId) {
    if (!this.variantPrefetch) this.variantPrefetch = new Map();
    if (this.variantPrefetch.has(variantId)) return;
    if (this.variantPrefetch.size >= 12) return; // long swatch rows must not grow this unbounded

    const conn = navigator.connection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

    // Resolves to null on any failure so the click just falls back to a live
    // fetch — a prefetch must never be able to break a variant change.
    const pending = fetch(this.variantSectionUrl(variantId))
      .then((response) => (response.ok ? response.text() : null))
      .catch(() => null);
    this.variantPrefetch.set(variantId, pending);
  }

  takePrefetchedVariantSection(variantId) {
    const pending = this.variantPrefetch && this.variantPrefetch.get(variantId);
    if (!pending) return null;
    this.variantPrefetch.delete(variantId); // single use: never serve stale price/inventory twice
    return pending;
  }

  /* AAS-5675: drop a cross-dissolve's pending fade-out. The outgoing images
   * are held at opacity 0 with fill: forwards until the commit replaces their
   * nodes; if that commit never happens (a failed render), cancelling restores
   * them to the colour that is still on screen. */
  cancelVariantFadeOut() {
    if (!this.variantFadeOuts) return;
    for (const animation of this.variantFadeOuts) animation.cancel();
    this.variantFadeOuts = null;
  }

  /* AAS-4992 — in-place loading state for the media region, replacing the
   * body-level crossfade clones (see fullSwap). Set synchronously on click so
   * there is immediate feedback, cleared when the swap commits.
   *
   * It is an ATTRIBUTE only — the styling lives in section-main-product.css and
   * must never put opacity/transform/filter on an ancestor of the desktop hero:
   * those create a containing block for position:fixed descendants and would
   * re-anchor .product__single-image to the wrapper, wrecking the scroll morph.
   * The CSS therefore dims the <img> elements themselves. */
  setVariantMediaLoading(loading) {
    const roots = [document.getElementById(`ProductMedia-${this.dataset.section}`)]
      .concat(Array.from(document.querySelectorAll('[data-variant-media-extra][id]')))
      .filter(Boolean);
    for (const root of roots) {
      root.toggleAttribute('data-variant-loading', loading);
      root.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
    clearTimeout(this.variantLoadingTimer);
    // A stalled or failed render must never leave the gallery dimmed for good.
    if (loading) {
      this.variantLoadingTimer = setTimeout(() => this.setVariantMediaLoading(false), 8000);
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    /* AAS-4992 — one variant render owns the DOM at a time. Rapid swatch
     * clicking used to leave N section fetches in flight, each with its own
     * decode gate and its own crossfade clones, all racing to repaint the
     * gallery. A newer click now aborts the older fetch outright, and every
     * async continuation below is gated on this token. The token also beats the
     * old `currentVariant.id !== requestedVariantId` test, which passed for an
     * A → B → A click run and let A's stale response repaint over the live one. */
    const token = (this.variantRenderToken = (this.variantRenderToken || 0) + 1);
    if (this.variantRenderController) this.variantRenderController.abort();
    const controller = (this.variantRenderController = new AbortController());
    const superseded = () => token !== this.variantRenderToken;

    // Synchronous, so the click has feedback before the fetch even starts.
    this.setVariantMediaLoading(true);

    const fetchSection = () =>
      fetch(this.variantSectionUrl(requestedVariantId), { signal: controller.signal }).then((response) =>
        response.text()
      );
    const prefetched = this.takePrefetchedVariantSection(requestedVariantId);

    (prefetched ? prefetched.then((text) => text || fetchSection()) : fetchSection())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (!this.currentVariant || superseded()) {
          return;
        }

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateStickyImage(sectionId, html);
        this.updateStickyPrice(sectionId, html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
          true,
          addButtonUpdated
        );

        // AAS-5067: the back-in-stock drawer's product summary is rendered
        // server-side for the requested variant inside this same section —
        // swap it wholesale so the drawer always mirrors the PDP's exact
        // selection (colourway image, variant title, price). The summary is
        // read-only; the email form sits outside the swapped node, so typed
        // input survives.
        document.querySelectorAll('[data-back-in-stock-refresh][id]').forEach((live) => {
          const fresh = html.getElementById(live.id);
          if (!fresh) return;
          live.replaceWith(document.importNode(fresh, true));
        });
        const stickyAddButtonUpdated = html.getElementById(`StickyProductSubmitButton-${sectionId}`);
        this.toggleStickyAddButton(
            stickyAddButtonUpdated ? stickyAddButtonUpdated.hasAttribute('disabled') : true,
            window.variantStrings.soldOut
        );

        // Variant media: swap the product media wrapper from the re-fetched section.
        // The server renders the gallery for the requested variant (it reads
        // selected_or_first_available_variant, resolved by ?variant=). Wrapped in the
        // View Transitions API for a natural crossfade; falls back to an instant swap.
        // --- Variant media swap -------------------------------------------------
        // Primary: the whole #ProductMedia wrapper (holds the desktop gallery,
        // lightbox, mobile hero, splide — every media block that lives inside it).
        const mediaSource = html.getElementById(`ProductMedia-${sectionId}`);
        const mediaDestination = document.getElementById(`ProductMedia-${this.dataset.section}`);

        /* AAS-5675 — the layout row, one level ABOVE the swapped wrapper.
         * `.product--scroll_triptych` / `.product--media` / `.product--triptych-fallback`
         * are decided per VARIANT (main-product.liquid resolves the gallery
         * routing off the selected variant's PIM assets), so a colour whose
         * assets are too thin for the triptych renders the single-image
         * fallback instead. That decision is stamped on this row, which the
         * media swap never touches — the stale modifier then mis-styled the
         * incoming markup AND, decisively, misled product-about.js: its
         * isApparel / isApparelFallback forks are plain
         * document.querySelector() calls on these classes, and apparel mode
         * pins the hero at opacity:0 until the About region scrolls in. Result
         * on either crossing (full -> fallback and back): the media region
         * swapped in correctly and then stayed blank until a reload.
         * Resynced inside swapMedia() below, before the DOM commit, so both
         * the CSS and the `pdp:media-swapped` re-inits see the right layout. */
        const layoutSource = html.getElementById(`ProductLayout-${sectionId}`);
        const layoutDestination = document.getElementById(`ProductLayout-${this.dataset.section}`);

        // Extra: any variant-dependent media region rendered OUTSIDE #ProductMedia
        // (e.g. the apparel mobile gallery, which sits after the product info on
        // mobile). These opt in with `data-variant-media-extra` + a stable id; we
        // swap each from the re-fetched section so they track the variant too. This
        // is the general contract — add the attribute to any future out-of-wrapper
        // media block and it works with no JS change. See docs/pim-variant-media-swap.md.
        // If the new variant lacks that block, the source node is absent → empty the
        // stale one rather than leaving the previous variant's media behind.
        const extraDestinations = Array.from(
          document.querySelectorAll('[data-variant-media-extra][id]')
        );

        // Identity of the visible media, built from stable server attributes
        // that client JS (Splide, overlay relocation) doesn't rewrite.
        //   activeId  — the selected slide's media id (which image is shown)
        //   idSet     — the full set of slide media ids (which images exist)
        // Comparing these lets us pick the cheapest possible update:
        //   • nothing changed (size-only on a one-image product)  → do nothing
        //   • same idSet, different active (colour on a product whose colours
        //     are all slides of one gallery) → just navigate the existing
        //     carousel to the other slide (native fade, no rebuild)
        //   • different idSet (per-variant PIM galleries) → full media swap
        // Re-initialising the whole Splide gallery on every change caused a
        // blink (size) and a change-then-reload flash (colour).
        const mediaIdentity = (root) => {
          if (!root) return { activeId: '', idSet: '' };
          const activeSlide =
            root.querySelector('.splide__slide[data-selected="true"]') ||
            root.querySelector('.splide__slide.is-active');
          const heroImg =
            root.querySelector('.product__single-image-img') ||
            root.querySelector('.apparel-mobile-hero__img') ||
            root.querySelector('.pdp-gallery-apparel__item img');
          const activeId = activeSlide
            ? activeSlide.getAttribute('data-media-id') || ''
            : heroImg
              ? heroImg.getAttribute('src') || ''
              : '';
          const idSet = Array.from(root.querySelectorAll('.splide__slide[data-media-id]'))
            .map((el) => el.getAttribute('data-media-id'))
            .join(',');
          return { activeId, idSet };
        };

        const srcIdentity = mediaSource ? mediaIdentity(mediaSource) : null;
        const dstIdentity = mediaDestination ? mediaIdentity(mediaDestination) : null;

        const sameIdSet =
          srcIdentity && dstIdentity && srcIdentity.idSet !== '' && srcIdentity.idSet === dstIdentity.idSet;
        const activeChanged =
          srcIdentity && dstIdentity && srcIdentity.activeId !== dstIdentity.activeId;
        const idSetChanged =
          srcIdentity && dstIdentity ? srcIdentity.idSet !== dstIdentity.idSet : false;

        const extraChanged = extraDestinations.some((dest) => {
          const src = html.getElementById(dest.id);
          return (src ? src.innerHTML : '') !== dest.innerHTML;
        });

        /* AAS-5675: a triptych <-> single-image-fallback crossing changes the
         * whole layout, and the cheap paths below cannot express that — the
         * no-op path would leave the previous colour's markup under the new
         * layout, and in-place carousel nav does not exist across the two.
         * Force the full server-rendered swap whenever the modifiers differ. */
        const layoutChanged =
          !!layoutSource && !!layoutDestination && layoutSource.className !== layoutDestination.className;

        // In-place navigation: the target image is already a slide in the live
        // gallery — just move the carousel to it. No innerHTML swap, no Splide
        // re-init, so it's as smooth as the no-op size change. Returns false if
        // the carousel/Splide instance isn't available so we can fall back.
        const navigateInPlace = () => {
          const gc = mediaDestination && mediaDestination.querySelector('gallery-carousel');
          if (!gc || !gc.main || typeof gc.main.go !== 'function') return false;

          const srcSlides = Array.from(mediaSource.querySelectorAll('.splide__slide'));
          let targetIndex = srcSlides.findIndex(
            (s) => s.getAttribute('data-selected') === 'true' || s.classList.contains('is-active')
          );
          if (targetIndex < 0) targetIndex = 0;

          const dstSlides = Array.from(
            gc.querySelectorAll('.splide__list > .splide__slide:not(.splide__slide--clone)')
          );
          const targetSlide = dstSlides[targetIndex];
          if (!targetSlide) return false;

          dstSlides.forEach((s, i) => {
            if (i === targetIndex) s.setAttribute('data-selected', 'true');
            else s.removeAttribute('data-selected');
          });

          gc.main.go(targetIndex);

          // Keep the absolutely-positioned Gallery trigger anchored to the now-
          // active slide (inactive slides collapse to height:0 in adapt mode).
          const trigger = mediaDestination.querySelector('.pdp-apparel-overlay__btn');
          if (trigger && trigger.closest('.splide__slide') !== targetSlide) {
            targetSlide.style.position = 'relative';
            targetSlide.appendChild(trigger);
          }
          return true;
        };

        // Preserve product-level scroll-hero cutouts across full swaps. The apparel
        // triptych cutout (.product__single-image) is sourced from a product-level
        // image (custom.product_image) — identical for every variant — and is
        // position:fixed + JS-managed (product-about.js). Re-rendering it makes it
        // flash and needlessly re-downloads the 2500px asset. Keep the SAME node:
        // detach before the innerHTML wipe, re-insert over its fresh duplicate after.
        // Only when it has no variant-aware descendant (the accessory/ski layout nests
        // the overlay, which IS variant-specific, inside the cutout — those must swap).
        let preservedCutouts = [];
        if (mediaSource && mediaDestination) {
          preservedCutouts = Array.from(
            mediaDestination.querySelectorAll('.product__single-image')
          ).filter((n) => !n.querySelector('pdp-apparel-overlay'));
        }

        /* AAS-4992 — asset tags inside the swapped region.
         *
         * INVARIANT: no <link rel="stylesheet"> may be rendered inside
         * #ProductMedia-<section> or a [data-variant-media-extra] region. The
         * innerHTML wipe below removes it from the document, which drops its
         * rules INSTANTLY, and the re-inserted copy reapplies asynchronously —
         * anything styled by it flashes unstyled in between. That is what made
         * the apparel overlay backdrop (hidden purely by opacity:0/visibility:
         * hidden, and parked on <body>) appear to open and shut on the first
         * colour switch. Declare such stylesheets in the section's asset block
         * instead — see sections/main-product.liquid. This cannot be repaired
         * from here: re-homing a live <link> means removing it, which reopens
         * the same gap.
         *
         * <script src> IS handled: re-inserting one re-downloads and re-runs it
         * on every single variant change, for no benefit (the components behind
         * them all guard their customElements.define). Strip them. */
        const stripReExecutingScripts = (root) => {
          if (!root) return;
          for (const node of root.querySelectorAll('script[src]')) node.remove();
        };
        if (mediaSource) stripReExecutingScripts(mediaSource);
        extraDestinations.forEach((dest) => stripReExecutingScripts(html.getElementById(dest.id)));

        /* AAS-5675 — every DOM commit in here runs arbitrary component code:
         * an innerHTML write runs disconnectedCallback on every custom element
         * it removes and connectedCallback on every one it inserts. A throw in
         * any of them used to propagate out of swapMedia and abort the rest of
         * it, so `pdp:media-swapped` never fired and the controllers that
         * re-init off it (product-about.js's scroll-hero above all) went on
         * managing detached nodes — the gallery stayed blank until a reload.
         * Exactly that happened via pdp-gallery-apparel.js's _removeDragClones
         * on an uninitialised mobile gallery (fixed at its source too). The
         * dispatch is the contract in docs/pim-variant-media-swap.md and must
         * survive a misbehaving component, so each commit is isolated and the
         * dispatch runs from a `finally`. Errors are logged, never swallowed
         * quietly — console.error is how this one surfaced. */
        const commitMedia = () => {
          if (!mediaSource || !mediaDestination) return;
          mediaDestination.innerHTML = mediaSource.innerHTML;
          if (!preservedCutouts.length) return;
          const fresh = Array.from(
            mediaDestination.querySelectorAll('.product__single-image')
          ).filter((n) => !n.querySelector('pdp-apparel-overlay'));
          preservedCutouts.forEach((node, i) => {
            const freshNode = fresh[i];
            if (!freshNode) return;
            /* AAS-4874: the apparel About panel is VARIANT-level now
             * (pim.assets.main_image per colour) — the blanket "identical
             * for every variant" preservation would reinstate the old
             * colour over the freshly rendered one. Keep the old node
             * ONLY when the fresh render shows the same image (legacy
             * product-level cutouts, size-only changes) — that retains
             * the no-flash/no-redownload benefit where it still holds. */
            const oldImg = node.querySelector('img');
            const freshImg = freshNode.querySelector('img');
            const oldSrc = oldImg ? oldImg.getAttribute('src') : '';
            const freshSrc = freshImg ? freshImg.getAttribute('src') : '';
            if (oldSrc === freshSrc) freshNode.replaceWith(node);
          });
        };

        const swapMedia = () => {
          // AAS-5675: layout modifiers first — the media below is styled by
          // them, and product-about.js / pdp-gallery-apparel.js re-init off the
          // `pdp:media-swapped` dispatched at the end of this same callback.
          if (layoutSource && layoutDestination) {
            layoutDestination.className = layoutSource.className;
          }
          try {
            try {
              commitMedia();
            } catch (error) {
              console.error('variant media swap: wrapper commit failed', error);
            }
            extraDestinations.forEach((dest) => {
              const src = html.getElementById(dest.id);
              try {
                dest.innerHTML = src ? src.innerHTML : '';
              } catch (error) {
                console.error('variant media swap: extra region failed', dest.id, error);
              }
            });
          } finally {
            // Fired AFTER the DOM commit so listeners that manage nodes inside the
            // swapped media — e.g. product-about.js's scroll-hero
            // (.product__single-image) — re-init off this. See docs/pim-variant-media-swap.md.
            document.dispatchEvent(
              new CustomEvent('pdp:media-swapped', { detail: { sectionId } })
            );
          }
        };

        // The media images the user actually sees — the decode gate's input,
        // and the set the cross-dissolve below animates.
        const VISIBLE_MEDIA_IMGS =
          '.product__single-image-img, .apparel-mobile-hero__img, ' +
          '.splide__slide[data-selected="true"] img, .splide__slide.is-active img, ' +
          '.pdp-gallery-apparel__item img';

        /* AAS-5675 — cross-dissolve. The swap committed the new colour in a
         * single frame, which read as a hard cut. Out through the page ground
         * and back in, rather than a true A-over-B crossfade: the outgoing
         * node is destroyed by the innerHTML write, so overlapping the two
         * would need a clone floating over the page — and that is precisely
         * what AAS-4874 tried (see fullSwap's note below), where a fixed clone
         * painted over the sections that were supposed to cover the hero.
         *
         * Animated with the Web Animations API on the <img> elements
         * themselves, deliberately, on both counts:
         *   • the IMG, not its wrapper — product-about.js owns
         *     `.product__single-image`'s inline opacity and the triptych owns
         *     its items', so writing there would fight them; opacity on the
         *     inner image composes with both.
         *   • WAAPI, not a CSS transition — it leaves no inline style behind
         *     to leak into whatever the controllers write next, and a pending
         *     one can be cancelled outright.
         * Only the imagery dissolves; the overlay button and chrome commit
         * instantly, which is the intent.
         *
         * The incoming images are already decoded by the gate below, so the
         * fade-in never stutters on a blank frame. */
        const FADE_OUT_MS = 120;
        const FADE_IN_MS = 240;
        const fadeableImgs = (roots) =>
          roots
            .filter(Boolean)
            .flatMap((root) => Array.from(root.querySelectorAll(VISIBLE_MEDIA_IMGS)))
            // display:none media (the mobile hero on desktop and vice versa)
            // has nothing to dissolve — animating it is pure cost.
            .filter((el) => el.getClientRects().length > 0);

        const prefersReducedMotion =
          typeof window.matchMedia === 'function' &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const canAnimate = !prefersReducedMotion && typeof Element.prototype.animate === 'function';

        /* Cross-dissolve the swap: fade what is on screen out, commit, fade the
         * new pixels in. `fill: 'forwards'` holds the outgoing images at zero
         * until their nodes are replaced — but it also means a render that dies
         * between the two halves would leave them invisible, so the pending
         * animations are tracked and the fetch chain's catch cancels them. */
        const dissolve = (commit) => {
          const dissolveRoots = [mediaDestination].concat(extraDestinations);
          if (!canAnimate) {
            commit();
            return;
          }
          const fades = fadeableImgs(dissolveRoots).map((el) =>
            el.animate(
              // From the CURRENT computed opacity, not a flat 1: a spam-clicked
              // switch starts while an earlier fade still holds the image part
              // way down, and re-starting from 1 would flash it back.
              [{ opacity: getComputedStyle(el).opacity }, { opacity: 0 }],
              { duration: FADE_OUT_MS, easing: 'ease-in', fill: 'forwards' }
            )
          );
          // Accumulated, never replaced: a superseded generation keeps holding
          // its images at zero (fill: forwards), so it has to stay cancellable
          // even after a newer one starts on the same nodes.
          this.variantFadeOuts = (this.variantFadeOuts || []).concat(fades);

          const fadeIn = () => {
            if (!this.currentVariant || superseded()) return;
            commit();
            /* Cancel BEFORE fading in, and mind the preserved cutout: theme.js
             * re-inserts the ORIGINAL `.product__single-image` node when the
             * fresh render carries the same image (AAS-4874), so that node
             * survives the commit still pinned at opacity 0 by its fade-out.
             * Cancelling releases it; on the nodes the commit really did
             * destroy this is a no-op. */
            this.cancelVariantFadeOut();
            for (const el of fadeableImgs(dissolveRoots)) {
              el.animate([{ opacity: 0 }, { opacity: 1 }], {
                duration: FADE_IN_MS,
                easing: 'ease-out',
              });
            }
          };

          if (!fades.length) {
            fadeIn();
            return;
          }
          // `finished` rejects when an animation is cancelled — a superseded
          // click does exactly that, and fadeIn()'s own guard drops it anyway.
          Promise.all(fades.map((a) => a.finished.catch(() => {}))).then(fadeIn);
        };

        const fullSwap = () => {
          /* AAS-4992 — NO body-level crossfade. AAS-4874 held the outgoing
           * images as position:fixed clones at z-index 3 over the page while
           * the incoming ones settled. A clone can only reproduce the element's
           * own paint, never what was painting OVER it, so once the desktop
           * scroll-morph hero (.product__single-image, parked at z-index 2 and
           * covered by the following sections) was the source, its clone
           * appeared on top of the sections that should hide it and then faded
           * — the reported "it appears for a brief moment then fades out".
           * Spam-clicking layered several of these at once.
           *
           * What replaces it: the media region carries [data-variant-loading]
           * from the click until the images have decoded (see
           * setVariantMediaLoading), so the wait is legible in place, inside
           * the gallery's own box, where nothing can float over unrelated
           * content. The pre-decode gate below still holds the swap until the
           * incoming images have pixels, which is what AAS-4874 actually
           * needed — the clones were a second safety net for the case where
           * its 3s cap fires first, and the loading state now covers that
           * honestly. AAS-5675: the loading dim then hands straight over to
           * the cross-dissolve, which owns the last 120ms down and the 240ms
           * back up — so the state ends in a fade, not a cut. */
          const runSwap = () => {
            // A newer colour/size click superseded this pending swap while its
            // images were decoding — drop it, its fetch cycle owns the DOM now.
            if (!this.currentVariant || superseded()) return;
            // AAS-5675: the commit rides inside the dissolve; the loading state
            // ends here, with the fade-out, so the two don't stack up.
            dissolve(swapMedia);
            this.setVariantMediaLoading(false);
          };

          // Decode every incoming visible image first so the swap lands on
          // painted pixels. The probes copy srcset/sizes — they must resolve
          // the SAME candidate URL the rendered <img> will pick, or the cache
          // misses and the gate is useless (the old src-only probe hit
          // exactly that with the responsive heroes). 3s race cap so a
          // stalled network can't wedge the variant switch.
          const candidates = mediaSource
            ? Array.from(mediaSource.querySelectorAll(VISIBLE_MEDIA_IMGS)).slice(0, 6)
            : [];
          if (candidates.length && typeof Image !== 'undefined') {
            const decodes = candidates.map((imgEl) => {
              const pre = new Image();
              const srcset = imgEl.getAttribute('srcset');
              const sizes = imgEl.getAttribute('sizes');
              if (srcset) pre.srcset = srcset;
              if (sizes) pre.sizes = sizes;
              pre.src = imgEl.getAttribute('src') || '';
              return pre.decode ? pre.decode().catch(() => {}) : Promise.resolve();
            });
            Promise.race([
              Promise.all(decodes),
              new Promise((resolve) => setTimeout(resolve, 3000)),
            ]).then(runSwap);
          } else {
            runSwap();
          }
        };

        // In-place carousel navigation only moves the (mobile) Splide — on
        // desktop the visible media is the fixed hero (.product__single-image),
        // which in-place nav never touches. If the hero's image changed and
        // we're on a desktop viewport, the in-place shortcut would leave the
        // OLD colour on screen for good — force the full swap instead.
        const desktopHeroStale = (() => {
          if (!window.matchMedia('(min-width: 1025px)').matches) return false;
          const dstHero = mediaDestination && mediaDestination.querySelector('.product__single-image-img');
          const srcHero = mediaSource && mediaSource.querySelector('.product__single-image-img');
          if (!dstHero || !srcHero) return false;
          return (srcHero.getAttribute('src') || '') !== (dstHero.getAttribute('src') || '');
        })();

        if (activeChanged && sameIdSet && !extraChanged && !desktopHeroStale && !layoutChanged) {
          // Same gallery, only the active slide differs (colour on a product
          // whose colours are all slides of one shared Splide gallery) →
          // navigate in place; fall back to a full swap if Splide isn't ready.
          // AAS-4992: in-place nav paints the correct image immediately — the
          // loading state has nothing left to wait for.
          if (!navigateInPlace()) fullSwap();
          else this.setVariantMediaLoading(false);
        } else if (activeChanged || idSetChanged || extraChanged || desktopHeroStale || layoutChanged) {
          // Media genuinely changed but can't be done in place: a different
          // image set (per-variant PIM gallery), a single-image / triptych hero
          // whose image changed, or an out-of-wrapper region changed → full
          // server-rendered swap. Preserves the original behaviour for every
          // non-shared-gallery PDP.
          fullSwap();
        } else {
          // Visible media unchanged (e.g. size-only) → leave it untouched, and
          // nothing is loading, so clear the state immediately.
          this.setVariantMediaLoading(false);
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .catch((error) => {
        // AAS-4992: aborting the previous render is the normal path now — it
        // must not surface as an unhandled rejection. The newer render owns the
        // loading state in that case, so leave it alone; a genuine failure
        // clears it and leaves the current variant's markup in place, as before.
        if (error && error.name === 'AbortError') return;
        if (!superseded()) this.setVariantMediaLoading(false);
        // AAS-5675: never leave the gallery mid-dissolve. The fade-out holds
        // the images at opacity 0 (fill: forwards) waiting for a commit that
        // now will not come — cancel it so the current colour stays visible.
        this.cancelVariantFadeOut();
        console.error('renderProductInfo failed', error);
      });
  }

  updateButtonPrice() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
  
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;
  
    const buttonPriceEl = addButton.querySelector('.buttonPrice');
    // AAS-4277: the mobile floating bar's price line (buy-buttons.liquid)
    const barPriceEl = addButton.querySelector('[data-bar-price]');

    if (!buttonPriceEl && !barPriceEl) return;

    const formattedPrice = this.currentVariant
      ? window.theme.marketMoney.stripHtml(window.theme.marketMoney.format(this.currentVariant.price))
      : '';
    if (buttonPriceEl) {
      buttonPriceEl.textContent = formattedPrice ? `— ${formattedPrice}` : '';
    }
    if (barPriceEl) {
      barPriceEl.textContent = formattedPrice;
    }
  }
  

  toggleAddButton(disable = true, text, modifyClass = true, sourceButton = null) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span:not(.product-form__submit-plus):not(.buttonPrice):not(.product-form__submit-pricebar)');
    if (!addButton) return;

    /* AAS-5067: merged sold-out CTA. The server renders the sold-out button as
     * the back-in-stock opener ("Sold out - Notify me", type=button, enabled,
     * data-notify-modal) when the block allows it — see buy-buttons.liquid.
     * On variant swaps renderProductInfo passes the re-fetched button here so
     * the live one mirrors that state; the label is copied from the source
     * because it carries the block's translated "Notify me" text, which
     * window.variantStrings doesn't know. */
    const notifyModal = sourceButton ? sourceButton.dataset.notifyModal : null;
    if (notifyModal) {
      addButton.removeAttribute('disabled');
      addButton.setAttribute('type', 'button');
      addButton.setAttribute('aria-haspopup', 'dialog');
      addButton.dataset.notifyModal = notifyModal;
      if (sourceButton.dataset.notifyLabelFull) {
        addButton.dataset.notifyLabelFull = sourceButton.dataset.notifyLabelFull;
        addButton.dataset.notifyLabelShort = sourceButton.dataset.notifyLabelShort || '';
      }
      addButton.classList.add('product-form__submit--notify');
      const sourceLabel = sourceButton.querySelector(
        'span:not(.product-form__submit-plus):not(.buttonPrice):not(.product-form__submit-pricebar)'
      );
      if (sourceLabel && addButtonText) addButtonText.textContent = sourceLabel.textContent;
      // re-fit for the live layout — the copied label is always the full one
      if (typeof fitNotifyLabels === 'function') fitNotifyLabels(productForm);
      return;
    }
    if (addButton.dataset.notifyModal) {
      addButton.setAttribute('type', 'submit');
      addButton.removeAttribute('aria-haspopup');
      delete addButton.dataset.notifyModal;
      delete addButton.dataset.notifyLabelFull;
      delete addButton.dataset.notifyLabelShort;
      addButton.classList.remove('product-form__submit--notify');
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = addButton.hasAttribute('data-preorder') ?
          window.variantStrings.preOrder :
          window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
  
  toggleStickyAddButton(disable = true, text, modifyClass = true) {
    const stickyProductForm = document.getElementById(`sticky-atc-${this.dataset.section}`);
    if (!stickyProductForm) return;
    const stickyAddButton = stickyProductForm.querySelector('[name="add"]');
    const stickyAddButtonText = stickyProductForm.querySelector('[name="add"] > span:not(.product-form__submit-plus):not(.buttonPrice):not(.product-form__submit-pricebar)');
  
    if (!stickyAddButton) return;
  
    if (disable) {
      stickyAddButton.setAttribute('disabled', 'disabled');
      if (text) stickyAddButtonText.textContent = text;
    } else {
      stickyAddButton.removeAttribute('disabled');
      stickyAddButtonText.textContent = stickyAddButton.hasAttribute('data-preorder') ? 
          window.variantStrings.preOrder : 
          window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }
  
  updateStickyPrice(sectionId, html) {
    const stickyPriceSourceId = `price-${sectionId}-sticky`;
    const stickyPriceDestinationId = `price-${sectionId}-sticky`;
    
    const source = html.getElementById(stickyPriceSourceId);
    const destination = document.getElementById(stickyPriceDestinationId);
  
    if (source && destination) {
      destination.innerHTML = source.innerHTML;
      destination.classList.toggle('hidden', source.classList.contains('hidden'));
    }
    const price = document.getElementById(`price-${sectionId}-sticky`);
    if (price) {
      price.classList.remove('hidden');
    }
  }
  updateStickyImage(sectionId, html) {
    const sourceImage = html.getElementById(`image-${sectionId}-sticky`);
    const destinationImage = document.getElementById(`image-${sectionId}-sticky`);

    if (sourceImage && destinationImage) {
      destinationImage.src = sourceImage.src;
      destinationImage.srcset = sourceImage.srcset;
      destinationImage.sizes = sourceImage.sizes;
    }
  }

  setUnavailable() {
    // AAS-4164: the product form is absent on catalog-only markets, so these must
    // be optional like the sticky lookups below. Every consumer downstream is
    // already null-guarded.
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button?.querySelector('[name="add"]');
    // AAS-5054: the label span must be selected like toggleAddButton does — a bare
    // `> span` grabs the FIRST span, which on the PDP button is the + icon
    // (.product-form__submit-plus): writing "unavailable" there nuked the SVG and
    // left the word wrapped inside the narrow icon slot for the rest of the visit.
    const addButtonText = button?.querySelector(
      '[name="add"] > span:not(.product-form__submit-plus):not(.buttonPrice):not(.product-form__submit-pricebar)'
    );
    const buttonSticky = document.getElementById(`sticky-atc-${this.dataset.section}`);
    const addButtonSticky = buttonSticky?.querySelector('[name="add"]');
    const addButtonTextSticky = buttonSticky?.querySelector(
      '[name="add"] > span:not(.product-form__submit-plus):not(.buttonPrice):not(.product-form__submit-pricebar)'
    );
    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(`price-${this.dataset.section}-sticky`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (addButton && addButtonText) {
      addButtonText.textContent = window.variantStrings.unavailable;
    }
    if (addButtonSticky && addButtonTextSticky) {
      addButtonTextSticky.textContent = window.variantStrings.unavailable;
    }
    if (price) price.classList.add('hidden');
    if (priceSticky) priceSticky.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);



class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

const setScrollbarWidth = () => {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
  } else {
    document.documentElement.style.setProperty("--scrollbar-width", "0px");
  }
};
setScrollbarWidth();


class ResponsiveImage extends HTMLElement {
  constructor() {
    super();
    this.onImageLoad = this.onImageLoad.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.img = this.querySelector('img');
    if (this.img) {
      this.img.addEventListener('load', this.onImageLoad);
      // Leave srcset intact: removing it makes the browser fetch the large
      // fallback src, even while native lazy loading is waiting for the image.
      if (this.img.complete && this.img.naturalWidth > 0) {
        this.onImageLoad();
      } else {
        this.img.classList.add('img-loading');
      }
      if (this.dataset.sizes === 'true' && 'ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.img);
      }
    }
  }

  disconnectedCallback() {
    if (this.img) {
      this.img.removeEventListener('load', this.onImageLoad);
      this.resizeObserver?.disconnect();
    }
  }

  onImageLoad() {
    this.img.classList.remove('img-loading');
    this.img.classList.add('img-loaded');
  }

  onResize(entries) {
    entries.forEach(entry => {
      if (this.dataset.sizes === 'true') {
        this.updateSizes(entry.target, entry.contentRect.width);
      }
    });
  }

  updateSizes(img, measuredWidth) {
    // Hidden drawers/carousels initially measure zero. Preserve their Liquid
    // sizes hint until the image has a real box, and avoid resize/write loops.
    const width = Math.ceil(measuredWidth);
    if (width <= 0) return;
    const sizes = `${width}px`;
    if (img.getAttribute('sizes') !== sizes) img.setAttribute('sizes', sizes);
  }
}

customElements.define('responsive-image', ResponsiveImage);


/**
 *  @class
 *  @function ViewportMedia
 */

if (!customElements.get('viewport-media')) {
  class ViewportMedia extends HTMLElement {
    constructor() {
      super();
      this.initObserver();
    }
  
    initObserver() {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadContent();
              this.observer.unobserve(entry.target);
              this.observer.disconnect();
            }
          });
        }, {
          rootMargin: '200px 0px 200px 0px' 
        });
  
        this.observer.observe(this);
      } else {
        this.loadContent();
      }
    }
  
    loadContent() {
      if (!this.getAttribute('loaded')) {
        const template = this.querySelector('template');
        if (template && template.content && template.content.firstElementChild) {
          const content = document.createElement('div');
          content.appendChild(template.content.firstElementChild.cloneNode(true));
    
          this.setAttribute('loaded', true);
          const deferredElement = this.appendChild(content.querySelector('video, iframe'));
    
          if (deferredElement.nodeName === 'IFRAME') {
            const src = deferredElement.getAttribute('data-src');
            if (src) {
              deferredElement.setAttribute('src', src);
            }
            deferredElement.onload = () => this.removePlaceholder();
          }
          if (deferredElement.nodeName === 'VIDEO') {
            const isAutoplay = deferredElement.getAttribute('autoplay');
            const poster = deferredElement.getAttribute('poster');
            if (!isAutoplay && poster) {
              deferredElement.setAttribute('poster', poster);
            }
            deferredElement.onloadeddata = () => {
             
              this.removePlaceholder();
              if (isAutoplay) {
                deferredElement.muted = true; 
                deferredElement.play().catch(error => {
                  console.warn('Autoplay failed:', error);
                });
              }
              this.initVideoControls(deferredElement);
            };
            deferredElement.load();
          }
        }
      }
    }


    initVideoControls(video) {
      const playPauseButton = this.querySelector('.video-play-pause');
      const muteToggleButton = this.querySelector('.video-mute-toggle');
      const progressFilled = this.querySelector('.video-progress-filled');
      let updateProgress;
    
      // Handle Play/Pause Button
      if (playPauseButton) {
        playPauseButton.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            playPauseButton.classList.remove('is-play');
            playPauseButton.classList.add('is-pause');
            updateProgress = requestAnimationFrame(updateProgressBar);
          } else {
            video.pause();
            playPauseButton.classList.remove('is-pause');
            playPauseButton.classList.add('is-play');
            cancelAnimationFrame(updateProgress);
          }
        });
    
        // Reset button state on video end
        video.addEventListener('ended', () => {
          if (playPauseButton) {
            playPauseButton.classList.remove('is-pause');
            playPauseButton.classList.add('is-play');
          }
        });
      }
    
      // Handle Mute/Unmute Button
      if (muteToggleButton) {
        muteToggleButton.addEventListener('click', () => {
          video.muted = !video.muted;
          if (video.muted) {
            muteToggleButton.classList.add('is-muted');
            muteToggleButton.classList.remove('is-unmuted');
          } else {
            muteToggleButton.classList.remove('is-muted');
            muteToggleButton.classList.add('is-unmuted');
          }
        });
      }
    
      // Handle Progress Bar
      if (progressFilled) {
        const updateProgressBar = () => {
          const percentage = (video.currentTime / video.duration) * 100 || 0;
          progressFilled.style.width = `${percentage}%`;
    
          // Continue updating while playing
          updateProgress = requestAnimationFrame(updateProgressBar);
        };
    
        video.addEventListener('timeupdate', updateProgressBar);
    
        // Reset progress on end
        video.addEventListener('ended', () => {
          cancelAnimationFrame(updateProgress);
          if (progressFilled) {
            progressFilled.style.width = '0%';
          }
        });
    
        // Start progress tracking when the video can play
        video.addEventListener('canplay', () => {
          if (progressFilled) {
            progressFilled.style.width = '0%';
          }
          if (!video.paused) updateProgress = requestAnimationFrame(updateProgressBar);
        });
      }
    }
    
    
    removePlaceholder() {
      const placeholder = this.querySelector('.video-placeholder');
      if (placeholder) {
        placeholder.style.display = 'none';
      }
    }
  }
  
  customElements.define('viewport-media', ViewportMedia);
}

/**
 *  @function
 *  @function enableTrackpadScroll
 */

function enableTrackpadScroll(splideInstance, trackElement, options = {}) {
  if (!trackElement || !splideInstance) return null;

  // Safari/WebKit scroll-lock fix (confirmed via live debugging on the QUAL
  // store): registering a NON-passive `wheel` listener on the Splide track makes
  // Safari latch the wheel gesture to the carousel, so PAGE scroll freezes while
  // the cursor is over the slider. The listener must stay non-passive on other
  // engines because it preventDefault()s horizontal swipes (otherwise the swipe
  // triggers browser back/forward navigation), so we can't just make it passive
  // without regressing that. Instead we skip the trackpad-wheel enhancement on
  // WebKit — the carousel is still navigable there via drag and arrows — while
  // Chromium/Firefox keep full trackpad wheel navigation.
  const ua = navigator.userAgent;
  const isWebKitSafari =
    /safari/i.test(ua) &&
    !/chrome|chromium|crios|android|edg|edgios|opr|fxios|samsungbrowser/i.test(ua);
  if (isWebKitSafari) return null;

  const perPage = splideInstance.options.perPage || 1;
  let handleWheel;

  // Only hijack the wheel for an UNAMBIGUOUSLY horizontal gesture. Vertical, zero,
  // and diagonal deltas (Safari emits horizontal drift + a long momentum tail
  // during a normal two-finger vertical scroll) must pass through to the page —
  // otherwise the non-passive preventDefault below locks page scrolling while the
  // cursor is over the track. Horizontal must dominate vertical by 2x AND clear a
  // floor, so vertical-intent scrolling never trips it regardless of drift.
  const MIN_DELTA_X = 2;
  const HORIZONTAL_RATIO = 2;
  const isHorizontalGesture = (e) => {
    const absX = Math.abs(e.deltaX);
    const absY = Math.abs(e.deltaY);
    return absX >= MIN_DELTA_X && absX > absY * HORIZONTAL_RATIO;
  };

  if (perPage === 1) {
    let lastWheel = 0;
    const lockTime = options.throttle || 800;

    handleWheel = (e) => {
      if (!isHorizontalGesture(e)) return;
      e.preventDefault();

      const now = Date.now();
      if (now - lastWheel < lockTime) return;
      lastWheel = now;

      if (e.deltaX > 0) splideInstance.go('>');
      else if (e.deltaX < 0) splideInstance.go('<');
    };
  } else {
    let accumulated = 0;
    const threshold = options.threshold || 40;

    handleWheel = (e) => {
      if (!isHorizontalGesture(e)) return;
      e.preventDefault();

      accumulated += e.deltaX;

      if (Math.abs(accumulated) > threshold) {
        if (accumulated > 0) splideInstance.go('>');
        else splideInstance.go('<');
        accumulated = 0;
      }
    };
  }

  trackElement.addEventListener('wheel', handleWheel, { passive: false });

  return () => {
    trackElement.removeEventListener('wheel', handleWheel);
  };
}

/**
 *  @function
 *  @function initializeProgressBar
 */
function initializeProgressBar(splideInstance, barElement) {
  if (!barElement || !splideInstance) return null;

  let progressRafId = null;

  const update = () => {
    if (!splideInstance) return;
    if (progressRafId) cancelAnimationFrame(progressRafId);

    progressRafId = requestAnimationFrame(() => {
      if (!splideInstance) return;
      const end = splideInstance.Components.Controller.getEnd() + 1;
      const rate = Math.min((splideInstance.index + 1) / end, 1);
      barElement.style.setProperty('--scale-x', rate);
      progressRafId = null;
    });
  };

  update();
  splideInstance.on('move', update);

  // Return cleanup function
  return () => {
    if (progressRafId) cancelAnimationFrame(progressRafId);
    if (splideInstance) splideInstance.off('move', update);
  };
}



/**
 *  @class
 *  @function SplideCarousel
 */


class SplideCarousel extends HTMLElement {
  constructor() {
    super();
    this.slideInstance = null;
    this.observer = null;
    this.isInViewport = false;
    this.rafId = null;
    this.lastVideoCheck = 0;
    this.timeouts = [];
    this.progressBarCleanup = null;
    this.boundHandlers = {};
    this.trackpadCleanup = null; 
  }

  connectedCallback() {
    if (!this.slideInstance) this.initializeSplide();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  initializeSplide() {
    const splideEl = this.querySelector('.splide');
    const options = splideEl?.getAttribute('data-splide');
    if (!options) return;
    
    try {
      const parsedOptions = JSON.parse(options);
      this.slideInstance = new Splide(splideEl, parsedOptions);
      
      this.slideInstance.on('mounted', () => {
        this.handleVideoPlayback();
      });
      
      this.slideInstance.on('moved', () => {
        this.handleVideoPlayback();
      });
      
      const videoTimeout = setTimeout(() => {
        if (this.slideInstance) {
          this.handleVideoPlayback();
        }
      }, 100);
      this.timeouts.push(videoTimeout);
      
      const progressTimeout = setTimeout(() => {
        if (this.slideInstance) {
          const bar = this.querySelector('.splide-carousel-progress-bar');
          this.progressBarCleanup = initializeProgressBar(this.slideInstance, bar);
        }
      }, 300);
      this.timeouts.push(progressTimeout);
      
      this.fixFadeRtlBug();
      this.slideInstance.mount();
      
      const track = this.querySelector('.splide__track');
      this.trackpadCleanup = enableTrackpadScroll(this.slideInstance, track);
      
    } catch (e) {
      console.error('Failed to initialize Splide carousel:', e);
    }
    
    this.initObserver();
    
    if (Shopify.designMode) {
      this.addShopifyEventListeners();
    }
  }

  initObserver() {
    if (!('IntersectionObserver' in window)) {
      this.isInViewport = true;
      return;
    }
    
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const wasInViewport = this.isInViewport;
        this.isInViewport = entry.isIntersecting;
        
        if (this.isInViewport && !wasInViewport) this.handleVideoPlayback();
        else if (!this.isInViewport && wasInViewport) this.pauseAllVideos();
      });
    }, { rootMargin: '0px 0px -50% 0px', threshold: 0.1 });
    
    this.observer.observe(this);
  }

  handleVideoPlayback() {
    if (!this.slideInstance || (!this.isInViewport && this.observer)) return;
    if (this.getAttribute('data-play-videos') === 'true') return;
    
    const now = Date.now();
    if (now - this.lastVideoCheck < 100) return;
    this.lastVideoCheck = now;
    
    if (this.rafId) cancelAnimationFrame(this.rafId);
    
    this.rafId = requestAnimationFrame(() => {
      if (!this.slideInstance) return;
      
      const slides = this.slideInstance.Components.Elements.slides;
      const currentIndex = this.slideInstance.index;
    
      slides.forEach((slide, index) => {
        const video = slide.querySelector('.shopable-video__video');
        if (!video) return;
        
        const isActive = !slide.classList.contains('is-clone') && currentIndex === index;
        
        if (isActive && video.paused) {
          video.play().catch(e => console.error('Error playing video:', e));
        } else if (!isActive && !video.paused) {
          video.pause();
        }
      });
      
      this.rafId = null;
    });
  }


  pauseAllVideos() {
    if (!this.slideInstance) return;
    
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    
    this.slideInstance.Components.Elements.slides.forEach(slide => {
      const video = slide.querySelector('.shopable-video__video');
      video && !video.paused && video.pause();
    });
  }

  addShopifyEventListeners() {
    this.boundHandlers.blockSelect = this.handleBlockSelect.bind(this);
    document.addEventListener('shopify:block:select', this.boundHandlers.blockSelect);
  }

  removeShopifyEventListeners() {
    if (this.boundHandlers.blockSelect) {
      document.removeEventListener('shopify:block:select', this.boundHandlers.blockSelect);
    }
  }

  handleBlockSelect(e) {
    const carousel = e.target.closest('splide-carousel');
    if (carousel === this && this.slideInstance) {
      const index = parseInt(e.target.getAttribute('data-splide-index'));
      if (!isNaN(index)) {
        this.slideInstance.go(index);
        this.slideInstance.Components.Autoplay?.pause();
      }
    }
  }


  fixFadeRtlBug() {
    if (this.getAttribute('data-fix-fade-rtl') !== 'true') return;
    if (document.documentElement.getAttribute('dir') !== 'rtl') return;
    
    this.slideInstance.on('ready', () => {
      this.querySelectorAll('.splide__slide').forEach(slide => {
        const transform = slide.style.transform;
        if (transform?.includes('-')) {
          slide.style.transform = transform.replace(/-/g, '');
        }
      });
    });
  }

  cleanup() {
    this.timeouts.forEach(t => clearTimeout(t));
    this.timeouts = [];
    
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    
    if (this.progressBarCleanup) {
      this.progressBarCleanup();
      this.progressBarCleanup = null;
    }
    
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    
    this.pauseAllVideos();

    if (this.trackpadCleanup) {
      this.trackpadCleanup();
      this.trackpadCleanup = null;
    }
    
    
    if (Shopify.designMode) this.removeShopifyEventListeners();
    
    if (this.slideInstance) {
      this.slideInstance.destroy();
      this.slideInstance = null;
    }
    
    this.isInViewport = false;
    this.lastVideoCheck = 0;
    this.boundHandlers = {};
    this.trackpadScrollElement = null;
  }
}

customElements.define('splide-carousel', SplideCarousel);


/**
 *  @class
 *  @function Slideshow
 */

if (!customElements.get('slide-show')) {
  class Slideshow extends HTMLElement {
    constructor() {
      super();
      this.slideInstance = null;
      this.observer = null;
      this.isInViewport = false;
      this.isUserInteracting = false;
      this.movingCursor = null;
      this.isMouseOverSlideshow = false;
      this.cursorUpdateRAF = null;
      this.lastMouseEvent = null;
      this.boundHandlers = {};
      this.trackpadCleanup = null;
    }

    connectedCallback() {
      this.init();
      this.initializeMovingCursor();
      this.initObserver();
      
      if (Shopify?.designMode) {
        this.addShopifyEventListeners();
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    init() {
      const options = this.getAttribute('data-splide');
      if (!options) return;

      try {
        this.slideInstance = new Splide(this, JSON.parse(options));

        if (this.getAttribute('data-pagination') === 'numbers') {
          this.slideInstance.on('pagination:mounted', this.customizePagination);
        }

        this.slideInstance.on('moved', (newIndex) => {
          this.handleVideoPlayback();
          this.updateSlideCounter(newIndex);
          this.handleFirstSlide();
        });

        this.fixFadeRtlBug();
        this.slideInstance.mount();
        this.updateSlideCounter(this.slideInstance.index);
        
        const track = this.querySelector('.splide__track');
        if (track && typeof enableTrackpadScroll === 'function') {
          this.trackpadCleanup = enableTrackpadScroll(this.slideInstance, track, { throttle: 800 });
        }

      } catch (e) {
        console.error('Failed to initialize Slideshow:', e);
      }
    }

    initObserver() {
      if (!('IntersectionObserver' in window)) {
        this.isInViewport = true;
        return;
      }

      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const wasInViewport = this.isInViewport;
          this.isInViewport = entry.isIntersecting;

          if (this.isInViewport && !wasInViewport) {
            this.handleVideoPlayback();
          } else if (!this.isInViewport && wasInViewport) {
            this.pauseAllVideos();
          }
        });
      }, { rootMargin: '0px 0px -50% 0px', threshold: 0.1 });

      this.observer.observe(this);
    }

    handleFirstSlide() {
      this.slideInstance.Components.Elements.slides.forEach(slide => {
        slide.classList.remove('first-slide');
      });
    }

    fixFadeRtlBug() {
      if (document.documentElement.getAttribute('dir') !== 'rtl') return;

      this.slideInstance.on('ready', () => {
        this.querySelectorAll('.splide__slide').forEach(slide => {
          const transform = slide.style.transform;
          if (transform?.includes('-')) {
            slide.style.transform = transform.replace(/-/g, '');
          }
        });
      });
    }

    handleVideoPlayback() {
      if (!this.slideInstance || (!this.isInViewport && this.observer)) return;

      this.slideInstance.Components.Elements.slides.forEach(slide => {
        const video = slide.querySelector('video');
        if (video) {
          video.muted = true;
          if (slide.classList.contains('is-active')) {
            video.paused && video.play().catch(e => console.error('Error playing video:', e));
          } else {
            !video.paused && video.pause();
          }
        }
      });
    }

    pauseAllVideos() {
      if (!this.slideInstance) return;

      this.slideInstance.Components.Elements.slides.forEach(slide => {
        const video = slide.querySelector('video');
        video && !video.paused && video.pause();
      });
    }

    updateSlideCounter(newIndex) {
      const currentSlideEl = this.querySelector('.current-slide');
      const totalSlidesEl = this.querySelector('.total-slides');
      const slideCounter = this.querySelector('.slide-counter');

      if (currentSlideEl && totalSlidesEl) {
        if (slideCounter) {
          slideCounter.classList.remove('slide-counter-progress');
          void slideCounter.offsetWidth;
        }

        totalSlidesEl.textContent = this.slideInstance.length;
        currentSlideEl.textContent = newIndex + 1;

        if (slideCounter) {
          slideCounter.classList.add('slide-counter-progress');
        }
      }
    }

    customizePagination(data) {
      data.list.classList.add('splide__pagination--custom');
      data.items.forEach(item => {
        item.button.textContent = String(item.page + 1).padStart(2, '0');
      });
    }

    initializeMovingCursor() {
      this.movingCursor = this.querySelector('.slideshow__moving-cursor');
      if (!this.movingCursor) return;

      this.boundHandlers = {
        mouseenter: this.handleMouseEnterSlideshow.bind(this),
        mouseleave: this.handleMouseLeaveSlideshow.bind(this),
        mousemove: this.handleMouseMoveOnSlideshow.bind(this),
        click: this.handleClickOnSlideshow.bind(this)
      };

      this.addEventListener('mouseenter', this.boundHandlers.mouseenter);
      this.addEventListener('mouseleave', this.boundHandlers.mouseleave);
      this.addEventListener('mousemove', this.boundHandlers.mousemove, { passive: true });
      this.addEventListener('click', this.boundHandlers.click);
    }

    isInteractiveElement(target) {
      return target?.closest?.('.slideshow-interactive-element, .splide__pagination, .splide__arrow');
    }

    handleMouseEnterSlideshow(event) {
      if (!this.movingCursor || (this.slideInstance && this.slideInstance.length <= 1)) return;
      
      this.isMouseOverSlideshow = true;
      this.lastMouseEvent = event;

      if (this.isInteractiveElement(event.target)) {
        this.hideCursor();
      } else {
        this.showCursor();
        this.updateMovingCursorState();
      }
    }

    handleMouseLeaveSlideshow() {
      this.isMouseOverSlideshow = false;
      this.lastMouseEvent = null;
      this.hideCursor();
      
      if (this.cursorUpdateRAF) {
        cancelAnimationFrame(this.cursorUpdateRAF);
        this.cursorUpdateRAF = null;
      }
    }

    handleMouseMoveOnSlideshow(event) {
      this.lastMouseEvent = event;

      if (!this.isMouseOverSlideshow || !this.movingCursor || 
          !this.slideInstance || this.slideInstance.length <= 1) {
        this.hideCursor();
        return;
      }

      if (this.isInteractiveElement(event.target)) {
        this.hideCursor();
        if (this.cursorUpdateRAF) {
          cancelAnimationFrame(this.cursorUpdateRAF);
          this.cursorUpdateRAF = null;
        }
        return;
      }

      if (!this.movingCursor.classList.contains('visible')) {
        this.showCursor();
      }

      if (this.cursorUpdateRAF) {
        cancelAnimationFrame(this.cursorUpdateRAF);
      }
      
      this.cursorUpdateRAF = requestAnimationFrame(() => {
        this.updateMovingCursorState();
        this.cursorUpdateRAF = null;
      });
    }

    updateMovingCursorState() {
      if (!this.movingCursor || !this.isMouseOverSlideshow || !this.lastMouseEvent) return;

      const event = this.lastMouseEvent;
      const rect = this.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      this.movingCursor.style.transform = `translate(${x}px, ${y}px)`;

      if (x < rect.width / 2) {
        this.movingCursor.classList.add('prev-style');
        this.movingCursor.classList.remove('next-style');
      } else {
        this.movingCursor.classList.add('next-style');
        this.movingCursor.classList.remove('prev-style');
      }
    }

    showCursor() {
      if (!this.movingCursor) return;
      this.movingCursor.classList.add('visible');
      this.classList.add('cursor-active');
    }

    hideCursor() {
      if (!this.movingCursor) return;
      this.movingCursor.classList.remove('visible');
      this.classList.remove('cursor-active');
    }

    handleClickOnSlideshow(event) {
      if (this.isInteractiveElement(event.target)) return;
      if (!this.slideInstance || this.slideInstance.length <= 1 || this.isUserInteracting) return;

      const rect = this.getBoundingClientRect();
      const x = event.clientX - rect.left;

      this.slideInstance.go(x < rect.width / 2 ? '<' : '>');
    }

    addShopifyEventListeners() {
      this.boundHandlers.blockSelect = this.handleBlockSelect.bind(this);
      this.boundHandlers.blockDeselect = this.handleBlockDeselect.bind(this);
      document.addEventListener('shopify:block:select', this.boundHandlers.blockSelect);
      document.addEventListener('shopify:block:deselect', this.boundHandlers.blockDeselect);
    }

    removeShopifyEventListeners() {
      if (this.boundHandlers.blockSelect) {
        document.removeEventListener('shopify:block:select', this.boundHandlers.blockSelect);
      }
      if (this.boundHandlers.blockDeselect) {
        document.removeEventListener('shopify:block:deselect', this.boundHandlers.blockDeselect);
      }
    }

    handleBlockSelect(event) {
      if (!this.contains(event.target)) return;

      const slideEl = event.target.closest('.splide__slide');
      if (this.slideInstance && slideEl && this.contains(slideEl)) {
        const index = parseInt(slideEl.getAttribute('data-splide-index'));
        if (!isNaN(index)) {
          this.slideInstance.go(index);
          this.isUserInteracting = true;
          this.slideInstance.Components.Autoplay?.pause();
        }
      }
    }

    handleBlockDeselect() {
      this.isUserInteracting = false;
    }

    stopCursorAnimation() {
      if (this.cursorUpdateRAF) {
        cancelAnimationFrame(this.cursorUpdateRAF);
        this.cursorUpdateRAF = null;
      }
    }

    cleanup() {
      this.stopCursorAnimation();

      if (this.trackpadCleanup) {
        this.trackpadCleanup();
        this.trackpadCleanup = null;
      }

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      this.pauseAllVideos();

      if (this.movingCursor) {
        this.removeEventListener('mouseenter', this.boundHandlers.mouseenter);
        this.removeEventListener('mouseleave', this.boundHandlers.mouseleave);
        this.removeEventListener('mousemove', this.boundHandlers.mousemove);
        this.removeEventListener('click', this.boundHandlers.click);
      }

      if (Shopify?.designMode) {
        this.removeShopifyEventListeners();
      }

      if (this.slideInstance) {
        this.slideInstance.destroy();
        this.slideInstance = null;
      }

      this.isInViewport = false;
      this.isMouseOverSlideshow = false;
      this.lastMouseEvent = null;
      this.boundHandlers = {};
    }
  }

  customElements.define('slide-show', Slideshow);
}

/**
 *  @class
 *  @function AsyncCarousel
 */

if (!customElements.get('async-carousel')) {
  class AsyncCarousel extends HTMLElement {
    constructor() {
      super();
      this.slideInstance = null;
      this.thumbnailInstance = null;
      this.isUserInteracting = false;
      this.thumbnails = null;
      this.currentThumbnail = null;
      this.trackpadCleanup = null;
      this.progressBarCleanup = null;
      this.rafId = null;
      this.boundHandlers = {};
      this.timeouts = [];
    }

    connectedCallback() {
      this.initCarousel();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    initCarousel() {
      const mainSlider = this.querySelector('[data-slider="main"]');
      const thumbnailSlider = this.querySelector('[data-slider="thumbnail"]');

      if (!mainSlider) return;

      try {
        const mainOptions = JSON.parse(mainSlider.getAttribute('data-splide') || '{}');
        this.slideInstance = new Splide(mainSlider, mainOptions);
        
        if (thumbnailSlider) {
          const thumbnailOptions = JSON.parse(thumbnailSlider.getAttribute('data-splide') || '{}');
          this.thumbnailInstance = new Splide(thumbnailSlider, thumbnailOptions);
          this.slideInstance.sync(this.thumbnailInstance);
          this.updateThumbnailARIA(thumbnailSlider);
        }

        this.fixFadeRtlBug();
        this.slideInstance.mount();
        
        if (this.thumbnailInstance) {
          this.thumbnailInstance.mount();
        }

        const track = mainSlider.querySelector('.splide__track');
        this.trackpadCleanup = enableTrackpadScroll(this.slideInstance, track, { throttle: 800 });
        
        const progressTimeout = setTimeout(() => {
          if (this.slideInstance) {
            const bar = this.querySelector('.splide-carousel-progress-bar');
            this.progressBarCleanup = initializeProgressBar(this.slideInstance, bar);
          }
        }, 300);
        this.timeouts.push(progressTimeout);

        this.initThumbnails();

        if (Shopify?.designMode) {
          this.addShopifyEventListeners();
        }
      } catch (e) {
        console.error('Failed to initialize AsyncCarousel:', e);
      }
    }

    addShopifyEventListeners() {
      this.boundHandlers.blockSelect = this.handleBlockSelect.bind(this);
      this.boundHandlers.blockDeselect = this.handleBlockDeselect.bind(this);
      document.addEventListener('shopify:block:select', this.boundHandlers.blockSelect);
      document.addEventListener('shopify:block:deselect', this.boundHandlers.blockDeselect);
    }

    removeShopifyEventListeners() {
      if (this.boundHandlers.blockSelect) {
        document.removeEventListener('shopify:block:select', this.boundHandlers.blockSelect);
      }
      if (this.boundHandlers.blockDeselect) {
        document.removeEventListener('shopify:block:deselect', this.boundHandlers.blockDeselect);
      }
    }

    handleBlockSelect(event) {
      if (!this.contains(event.target)) return;

      const blockElement = event.target;
      const index = parseInt(blockElement.getAttribute('data-splide-index'));

      if (!isNaN(index) && this.slideInstance) {
        this.slideInstance.go(index);
        this.isUserInteracting = true;
        this.slideInstance.Components.Autoplay?.pause();
      }
    }

    handleBlockDeselect(event) {
      if (!this.contains(event.target)) return;
      this.isUserInteracting = false;
    }

    initThumbnails() {
      this.thumbnails = this.querySelectorAll('.thumbnail-item');
      if (!this.thumbnails.length) return;

      this.thumbnails.forEach((thumbnail, index) => {
        const handler = () => this.slideInstance?.go(index);
        thumbnail.addEventListener('click', handler);
        
        if (!this.boundHandlers.thumbnails) {
          this.boundHandlers.thumbnails = [];
        }
        this.boundHandlers.thumbnails.push({ element: thumbnail, handler });
      });

      const updateThumbnail = () => {
        if (this.rafId) cancelAnimationFrame(this.rafId);

        this.rafId = requestAnimationFrame(() => {
          const thumbnail = this.thumbnails[this.slideInstance.index];
          if (thumbnail) {
            if (this.currentThumbnail) {
              this.currentThumbnail.classList.remove('is-active');
            }
            thumbnail.classList.add('is-active');
            this.currentThumbnail = thumbnail;
          }
          this.rafId = null;
        });
      };

      this.slideInstance.on('mounted move', updateThumbnail);

      if (this.thumbnails.length > 0) {
        this.thumbnails[0].classList.add('is-active');
        this.currentThumbnail = this.thumbnails[0];
      }
    }


    fixFadeRtlBug() {
      if (this.getAttribute('data-fix-fade-rtl') !== 'true') return;
      if (document.documentElement.getAttribute('dir') !== 'rtl') return;

      this.slideInstance.on('ready', () => {
        const mainSlider = this.querySelector('[data-slider="main"]');
        if (!mainSlider) return;

        mainSlider.querySelectorAll('.splide__slide').forEach(slide => {
          const transform = slide.style.transform;
          if (transform?.includes('-')) {
            slide.style.transform = transform.replace(/-/g, '');
          }
        });
      });
    }

    updateThumbnailARIA(thumbnailSlider) {
      const thumbnailItems = thumbnailSlider.querySelectorAll('.splide__slide');
      thumbnailItems.forEach(thumbnailItem => {
        thumbnailItem.setAttribute('role', 'group');
      });
    }

    cleanup() {
      this.timeouts.forEach(t => clearTimeout(t));
      this.timeouts = [];

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      if (this.progressBarCleanup) {
        this.progressBarCleanup();
        this.progressBarCleanup = null;
      }

      if (this.trackpadCleanup) {
        this.trackpadCleanup();
        this.trackpadCleanup = null;
      }

      if (this.boundHandlers.thumbnails) {
        this.boundHandlers.thumbnails.forEach(({ element, handler }) => {
          element.removeEventListener('click', handler);
        });
      }

      if (Shopify?.designMode) {
        this.removeShopifyEventListeners();
      }

      if (this.slideInstance) {
        this.slideInstance.destroy();
        this.slideInstance = null;
      }

      if (this.thumbnailInstance) {
        this.thumbnailInstance.destroy();
        this.thumbnailInstance = null;
      }

      this.thumbnails = null;
      this.currentThumbnail = null;
      this.boundHandlers = {};
    }
  }

  customElements.define('async-carousel', AsyncCarousel);
}


/**
 *  @class
 *  @function GalleryCarousel
 */

if (!customElements.get('gallery-carousel')) {
  class GalleryCarousel extends HTMLElement {
    constructor() {
      super();
      this.main = null;
      this.thumbnails = null;
      this.shouldAutoplay = false;
      this.originalSlides = [];
      this.originalThumbnails = [];
      this.activeMediaComponents = new Map();
      this.rafId = null;
      this.boundHandlers = {};
      this.trackpadCleanup = null; 
    }

    connectedCallback() {
      const mainCarousel = this.querySelector('[id^="Main-Carousel"]');
      const thumbnailCarousel = this.querySelector('[id^="Thumbnail-Carousel"]');

      if (!mainCarousel) {
        console.error('Main carousel element not found.');
        return;
      }

      this.originalSlides = [...mainCarousel.querySelectorAll('.splide__slide')];
      this.originalThumbnails = thumbnailCarousel ? [...thumbnailCarousel.querySelectorAll('.splide__slide')] : [];
    
      this.shouldAutoplay = this.getAttribute('data-autoplay') === 'true';
      mainCarousel.classList.add('is-initializing');
    
      const mainOptions = this.getCarouselOptions(mainCarousel);
      const thumbnailOptions = thumbnailCarousel ? this.getCarouselOptions(thumbnailCarousel) : null;
      const initialSlideIndex = this.getInitialSlideIndex(thumbnailCarousel || mainCarousel);

      mainOptions.start = initialSlideIndex;
      if (thumbnailOptions) thumbnailOptions.start = initialSlideIndex;
    
      this.initializeCarousels(mainCarousel, mainOptions, thumbnailCarousel, thumbnailOptions);
    
      const enableFiltering = this.dataset.mediaGrouping === "true";
      if (enableFiltering) {
        const defaultFilter = this.dataset.filterSelected;
        this.selectedSlideIndex = initialSlideIndex;
        this.filterSlides(defaultFilter, true);
        
        this.boundHandlers.filterChange = (e) => this.filterSlides(e.target.value, false);
        
        document.querySelectorAll(".variant-picker__color input[type='radio']").forEach((radio) => {
          radio.addEventListener("change", this.boundHandlers.filterChange);
        });
      }

      if (this.hasAttribute('desktop-grid') && window.innerWidth >= 768) {
        this.autoplayFirstVideoInGrid();
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    getCarouselOptions(carouselElement) {
      return JSON.parse(carouselElement.getAttribute('data-splide') || '{}');
    }

    getInitialSlideIndex(thumbnailCarousel) {
      if (!thumbnailCarousel) return 0;
      const selectedThumbnailSlide = thumbnailCarousel.querySelector('.splide__slide[data-selected="true"]');
      if (selectedThumbnailSlide) {
        return [...thumbnailCarousel.querySelectorAll('.splide__slide')].indexOf(selectedThumbnailSlide);
      }
      return 0;
    }

    initializeCarousels(mainCarousel, mainOptions, thumbnailCarousel, thumbnailOptions) {
      this.main = new Splide(mainCarousel, mainOptions);
      this.thumbnails = thumbnailCarousel ? new Splide(thumbnailCarousel, thumbnailOptions) : null;
      const isVerticalThumbnail = thumbnailCarousel ? thumbnailCarousel.getAttribute('data-thumbnail') === 'vertical' : false;

      if (this.thumbnails && isVerticalThumbnail) {
        this.thumbnails.on('mounted', () => {
          const thumbnailList = thumbnailCarousel.querySelector('.splide__list');
          if (thumbnailList) {
            thumbnailList.setAttribute('role', 'tablist');
          }
        });
        this.thumbnails.on('mounted', this.updateThumbnailARIA.bind(this));
      }
      
      this.main.on('mounted', () => {
        mainCarousel.classList.remove('is-initializing');
    
        if (this.main.index !== undefined) {
            this.updateSlideCounter(this.main.index);
        }
      });

      this.main.on('active', this.handleMainActiveSlide.bind(this));

      this.main.on('move', (newIndex, prevIndex) => {
        if (typeof prevIndex !== 'undefined' && prevIndex !== null) {
          const prevSlide = this.main.Components.Elements.slides[prevIndex];
          if (prevSlide) {
            this.pauseMediaInSlide(prevSlide);
          }
        }
      });

      if (this.thumbnails) {
        this.thumbnails.mount();
        this.main.sync(this.thumbnails);
      }
      this.main.mount();

      this.main.on('moved', (newIndex) => {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        
        this.rafId = requestAnimationFrame(() => {
          this.updateSlideCounter(newIndex);
          this.rafId = null;
        });
      });
      
      this.updateSlideCounter(this.main.index);
      const track = this.main.root.querySelector('.splide__track');
      this.trackpadCleanup = enableTrackpadScroll(this.main, track, { throttle: 800 });
    }

    pauseMediaInSlide(slideElement) {
      if (!slideElement) return;
      const mediaElements = slideElement.querySelectorAll(
        'deferred-media, product-model, video, iframe'
      );
      mediaElements.forEach(media => {
        if (typeof media.pause === 'function') {
          media.pause();
        } else if (media.nodeName === 'VIDEO') {
          media.pause();
        } else if (media.nodeName === 'IFRAME') {
          if (media.classList.contains('js-youtube')) {
            media.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (media.classList.contains('js-vimeo')) {
            media.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    }

    updateSlideCounter(newIndex) {
      const totalSlides = this.main.length;
      const currentSlideElement = this.querySelector('.current-slide');
      const totalSlidesElement = this.querySelector('.total-slides');

      if (currentSlideElement && totalSlidesElement) {
        totalSlidesElement.textContent = totalSlides;
        currentSlideElement.textContent = newIndex + 1;
      }
    }

    handleMainActiveSlide(newSlide) {
      const activeSlideElement = newSlide.slide;

      const hasProductModel = activeSlideElement.querySelector('product-model') !== null;
      if (this.main && this.main.Components && this.main.Components.Drag) {
        this.main.Components.Drag.disable(hasProductModel);
      }

      const mediaComponent = activeSlideElement.querySelector('deferred-media, product-model');

      if (mediaComponent) {
        if (this.shouldAutoplay) {
          if (typeof mediaComponent.activate === 'function') {
            mediaComponent.activate();
          } else if (typeof mediaComponent.play === 'function') {
            mediaComponent.play();
          }
        } else {
          if (typeof mediaComponent.pause === 'function') {
            mediaComponent.pause();
          }
        }
      }
      this.handleActiveSlide(activeSlideElement);
    }

    handleActiveSlide(slideElement) {
      if (slideElement && !slideElement.dataset.played && this.shouldAutoplay) {
         slideElement.dataset.played = true;
      }
    }

    updateCarouselImages(mediaId) {
      if (!this.main) {
        return;
      }
      const mainSlides = this.main.Components.Elements.slides;
      const targetSlide = mainSlides.find(slide => slide.getAttribute('data-media-id') === mediaId.toString());

      if (targetSlide) {
          const targetIndex = mainSlides.indexOf(targetSlide);
          if (targetIndex !== -1) {
              this.main.go(targetIndex, { transition: false });
          }
      }
      if (this.hasAttribute('desktop-grid') && window.innerWidth >= 768) {
        const galleryListsContainer = this.querySelector('.splide__gallery');
        if (galleryListsContainer) {
          const slides = galleryListsContainer.querySelectorAll('.splide__slide');
          
          const slideToMove = Array.from(slides).find(item => item.getAttribute('data-media-id') === mediaId.toString());
      
          if (slideToMove) {
            slides.forEach(slide => {
              if (slide !== slideToMove) {
                slide.classList.remove('splide__slide--current-variant');
              }
            });
            slideToMove.classList.add('splide__slide--current-variant');
      
            if (galleryListsContainer.firstElementChild !== slideToMove) {
              galleryListsContainer.insertBefore(slideToMove, galleryListsContainer.firstElementChild);
      
              const headerElem = document.querySelector('.header');
              const headerOffset = headerElem ? headerElem.offsetHeight + 16 : 16;
              const elementPosition = slideToMove.getBoundingClientRect().top + window.pageYOffset;
              const offsetPosition = elementPosition - headerOffset;
      
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
          }
        }
      }
    }

    updateThumbnailARIA() {
      if (!this.thumbnails || !this.thumbnails.Components || !this.thumbnails.Components.Elements.list) return;
      const thumbnailItems = this.thumbnails.Components.Elements.list.querySelectorAll('.splide__slide');

      thumbnailItems.forEach((thumbnailItem) => {
        thumbnailItem.setAttribute('role', 'tab');
      });
    }

    filterSlides(group, isInitialFilter = false) {
      const isDesktopGrid = this.hasAttribute('desktop-grid') && window.innerWidth >= 768;
      
      if (isDesktopGrid) {
        this.filterSlidesDesktopGrid(group);
        return;
      }
      
      this.filterSlidesCarousel(group, isInitialFilter);
    }

    autoplayFirstVideoInGrid() {
      if (!this.shouldAutoplay) return;
      
      const galleryContainer = this.querySelector('.splide__gallery');
      if (!galleryContainer) return;
      
      const slides = galleryContainer.querySelectorAll('.splide__slide');
      
      for (const slide of slides) {
        if (slide.style.display === 'none' || slide.classList.contains('hidden-by-filter')) {
          continue;
        }
        
        const mediaComponent = slide.querySelector('deferred-media, product-model');
        if (mediaComponent) {
          if (typeof mediaComponent.activate === 'function') {
            mediaComponent.activate();
          } else if (typeof mediaComponent.play === 'function') {
            mediaComponent.play();
          }
          break; 
        }
      }
    }

    filterSlidesDesktopGrid(group) {
      const galleryContainer = this.querySelector('.splide__gallery');
      if (!galleryContainer) return;
      
      const slides = galleryContainer.querySelectorAll('.splide__slide');
      let visibleCount = 0;
      let firstVisibleMediaFound = false;
      
      slides.forEach(slide => {
        const shouldShow = !group || group.trim() === "" || slide.dataset.mediaGroup === group;
        
        if (shouldShow) {
          slide.style.display = '';
          slide.classList.remove('hidden-by-filter');
          visibleCount++;
          
          const deferredMedia = slide.querySelector('deferred-media');
          if (deferredMedia) {
            if (deferredMedia.hasAttribute('loaded')) {
              this.ensureMediaFunctionality(deferredMedia);
            } 
            else if (deferredMedia.hasAttribute('autoplay')) {
              if (!deferredMedia.visibilityObserver) {
                deferredMedia._initiateAutoplayObserver();
              }
            }
            
            if (!firstVisibleMediaFound && this.shouldAutoplay) {
              if (typeof deferredMedia.activate === 'function') {
                deferredMedia.activate();
              } else if (typeof deferredMedia.play === 'function') {
                deferredMedia.play();
              }
              firstVisibleMediaFound = true;
            }
          }
        } else {
          slide.style.display = 'none';
          slide.classList.add('hidden-by-filter');
          
          const deferredMedia = slide.querySelector('deferred-media');
          if (deferredMedia) {
            if (deferredMedia.hasAttribute('playing')) {
              deferredMedia.pause();
            }
            
            if (deferredMedia.visibilityObserver) {
              deferredMedia.visibilityObserver.disconnect();
              deferredMedia.visibilityObserver = null;
            }
          }
        }
      });
      
      const currentSlideElement = this.querySelector('.current-slide');
      const totalSlidesElement = this.querySelector('.total-slides');
      
      if (currentSlideElement && totalSlidesElement) {
        currentSlideElement.textContent = visibleCount > 0 ? '1' : '0';
        totalSlidesElement.textContent = visibleCount;
      }
    }
    

    filterSlidesCarousel(group, isInitialFilter = false) {
      if (!this.main) {
        console.error('Splide instances not initialized');
        return;
      }

      let mainList = this.main.Components.Elements.list;
      let thumbList = this.thumbnails ? this.thumbnails.Components.Elements.list : null;

      if (!mainList) {
        console.error('Splide list element not found for main.');
        return;
      }

      this.saveMediaStates();

      mainList.innerHTML = "";
      if (thumbList) thumbList.innerHTML = "";
    
      let slidesToShow = this.originalSlides;
      let thumbsToShow = this.originalThumbnails;
    
      if (group && group.trim() !== "") {
        let filteredSlides = this.originalSlides.filter(slide => slide.dataset.mediaGroup === group);
        let filteredThumbs = this.originalThumbnails.filter(slide => slide.dataset.mediaGroup === group);

        if (filteredSlides.length > 0) {
            slidesToShow = filteredSlides;
            thumbsToShow = filteredThumbs;
        }
      }
    
      this.updateArrowVisibility(thumbsToShow.length);
    
      const mainFragment = document.createDocumentFragment();
      const thumbFragment = document.createDocumentFragment();
      
      slidesToShow.forEach(slide => {
        const clonedSlide = slide.cloneNode(true);
        mainFragment.appendChild(clonedSlide);
        this.initializeMediaInSlide(clonedSlide);
      });
      
      thumbsToShow.forEach(slide => {
        const clonedThumb = slide.cloneNode(true);
        thumbFragment.appendChild(clonedThumb);
      });
      
      mainList.appendChild(mainFragment);
      if (thumbList) thumbList.appendChild(thumbFragment);
    
      try {
          this.main.refresh();
          if (this.thumbnails) this.thumbnails.refresh();
    
          if (slidesToShow.length > 0) {
              let targetIndex = 0;
              
              if (isInitialFilter) {
                const selectedSlide = slidesToShow.find(slide => 
                  slide.querySelector('[data-selected="true"]') || 
                  slide.hasAttribute('data-selected')
                );
                
                if (selectedSlide) {
                  targetIndex = slidesToShow.indexOf(selectedSlide);
                }
              }
              
              this.main.go(targetIndex);
              if (this.thumbnails) this.thumbnails.go(targetIndex);
              this.updateSlideCounter(targetIndex);
              
              this.restoreMediaStates();
          } else {
              this.updateSlideCounter(-1);
              console.warn("No slides to display in the carousel after filtering.");
          }
      } catch (error) {
          console.error("Error refreshing Splide instances:", error);
      }
    
      this.querySelectorAll('responsive-image').forEach(responsiveImg => {
        if (responsiveImg.connectedCallback && typeof responsiveImg.connectedCallback === 'function') {
          responsiveImg.connectedCallback();
        }
        else if (responsiveImg.init && typeof responsiveImg.init === 'function') {
          responsiveImg.init();
        }
      });
    
      this.updateThumbnailARIA();
      if (this.trackpadCleanup) {
        this.trackpadCleanup();
      }
      const track = this.main.root.querySelector('.splide__track');
      this.trackpadCleanup = enableTrackpadScroll(this.main, track, { throttle: 800 });
    }

    initializeMediaInSlide(slide) {
      if (!slide) return;
      
      const deferredMedia = slide.querySelector('deferred-media');
      if (deferredMedia) {
        try {
          deferredMedia.removeAttribute('loaded');
          deferredMedia.removeAttribute('playing');
          deferredMedia.removeAttribute('has-play-pause-button');
          
          deferredMedia.mediaElement = null;
          deferredMedia.playerController = null;
          
          const poster = deferredMedia.querySelector('[id^="Deferred-Poster-"]');
          const template = deferredMedia.querySelector('template');
          
          if (poster && template) {
            const boundActivate = deferredMedia.activate.bind(deferredMedia);
            
            if (deferredMedia.boundActivate) {
              poster.removeEventListener('click', deferredMedia.boundActivate);
            }
            
            poster.addEventListener('click', boundActivate);
            
            poster.style.display = '';
            
            deferredMedia.poster = poster;
            deferredMedia.template = template;
            deferredMedia.boundActivate = boundActivate;
            
            if (deferredMedia.hasAttribute('autoplay') && deferredMedia._initiateAutoplayObserver) {
              deferredMedia._initiateAutoplayObserver();
            }
          }
        } catch (error) {
          console.error('Error initializing deferred-media:', error);
        }
      }
      
      const productModel = slide.querySelector('product-model');
      if (productModel) {
        try {
          if (productModel.connectedCallback) {
            productModel.connectedCallback();
          }
        } catch (error) {
          console.error('Error initializing product-model:', error);
        }
      }
    }

    ensureMediaFunctionality(mediaElement) {
      if (!mediaElement || mediaElement.nodeType !== 1) return;
      
      if (mediaElement.hasAttribute('loaded') && mediaElement.hasAttribute('autoplay')) {
        const playPauseButton = mediaElement.querySelector('.deferred-media-control__play-pause');
        if (playPauseButton && !mediaElement.hasAttribute('has-play-pause-button')) {
          const boundHandleClick = mediaElement._handlePlayPauseClick?.bind(mediaElement);
          if (boundHandleClick) {
            playPauseButton.addEventListener('click', boundHandleClick);
            mediaElement.setAttribute('has-play-pause-button', '');
            mediaElement.playPauseButton = playPauseButton;
          }
        }
      }
      
      const poster = mediaElement.querySelector('[id^="Deferred-Poster-"]');
      if (poster && !mediaElement.hasAttribute('loaded')) {
        const boundActivate = mediaElement.activate?.bind(mediaElement);
        if (boundActivate) {
          poster.removeEventListener('click', boundActivate);
          poster.addEventListener('click', boundActivate);
          mediaElement.boundActivate = boundActivate;
        }
      }
    }

    saveMediaStates() {
      this.activeMediaComponents.clear();
      this.querySelectorAll('deferred-media, product-model').forEach(media => {
        const mediaId = media.closest('[data-media-id]')?.dataset.mediaId;
        if (mediaId) {
          this.activeMediaComponents.set(mediaId, {
            isLoaded: media.hasAttribute('loaded'),
            isPlaying: media.hasAttribute('playing'),
            hasAutoplay: media.hasAttribute('autoplay')
          });
        }
      });
    }
    
    restoreMediaStates() {
      this.activeMediaComponents.forEach((state, mediaId) => {
        const slide = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (slide) {
          const media = slide.querySelector('deferred-media, product-model');
          if (media) {
            if (state.isLoaded && !media.hasAttribute('loaded')) {
              media._initializeMedia().then(loaded => {
                if (loaded && state.isPlaying) {
                  setTimeout(() => media.activate(), 100);
                }
              });
            }
            else if (state.isPlaying && media.hasAttribute('loaded')) {
              setTimeout(() => media.activate(), 100);
            }
            else if (state.hasAutoplay && !media.hasAttribute('loaded')) {
              media._initiateAutoplayObserver();
            }
          }
        }
      });
    }

    updateArrowVisibility(slideCount) {
      const arrows = this.querySelectorAll('.splide__arrows-thumbnail');
      const shouldShow = slideCount > 5;
    
      arrows.forEach(arrow => {
        if (shouldShow) {
          arrow.classList.remove('hidden');
        } else {
          arrow.classList.add('hidden');
        }
      });
    }

    cleanup() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      if (this.trackpadCleanup) {
        this.trackpadCleanup();
        this.trackpadCleanup = null;
      }

      if (this.boundHandlers.filterChange) {
        const radios = document.querySelectorAll(".variant-picker__color input[type='radio']");
        radios.forEach(radio => {
          radio.removeEventListener("change", this.boundHandlers.filterChange);
        });
      }

      if (this.main) {
        this.main.destroy();
        this.main = null;
      }

      if (this.thumbnails) {
        this.thumbnails.destroy();
        this.thumbnails = null;
      }

      this.originalSlides = [];
      this.originalThumbnails = [];
      this.activeMediaComponents.clear();
      this.boundHandlers = {};
      this.trackpadScrollElement = null;
    }
  }

  customElements.define('gallery-carousel', GalleryCarousel);
}




/**
 *  @class
 *  @function ProductRecommendations
 */
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.dataset.url ? this.loadRecommendations() : console.error('No data-url attribute found.');
    }

    async loadRecommendations() {
      // Optional intent chain, opt-in via data-intent-chain (e.g.
      // "complementary,related"): request each intent in order and render the
      // first that comes back with cards. Without the attribute the single
      // data-url fetch below runs exactly as before, so the cart drawer and the
      // PDP complementary snippet keep their current behaviour.
      const intents = (this.dataset.intentChain || '')
        .split(',')
        .map((intent) => intent.trim())
        .filter(Boolean);

      if (intents.length) {
        for (const intent of intents) {
          try {
            const markup = await this.fetchRecommendations(this.buildIntentUrl(intent));
            if (markup) {
              this.renderRecommendations(markup);
              return;
            }
          } catch (error) {
            // A failing intent must not sink the rest of the chain.
            console.error(`Error fetching "${intent}" product recommendations:`, error);
          }
        }
        console.warn(`No product recommendations found for intents: ${intents.join(', ')}`);
        return;
      }

      try {
        const markup = await this.fetchRecommendations(this.dataset.url);

        if (markup) {
          this.renderRecommendations(markup);
        } else {
          console.warn('No product recommendations found.');
        }
      } catch (error) {
        console.error('Error fetching product recommendations:', error);
      }
    }

    buildIntentUrl(intent) {
      const url = this.dataset.url;
      return `${url}${url.includes('?') ? '&' : '?'}intent=${encodeURIComponent(intent)}`;
    }

    async fetchRecommendations(url) {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Failed to fetch: ${response.status}`);

      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const recommendations = doc.querySelector('product-recommendations');

      return recommendations && recommendations.innerHTML.trim() ? recommendations.innerHTML : '';
    }

    renderRecommendations(html) {
      this.innerHTML = html;
      this.initCarousels();
      this.classList.add('product-recommendations--loaded');
    }

    initCarousels() {
      const carousels = this.querySelectorAll('splide-carousel');
      carousels.forEach(carousel => carousel.connectedCallback?.());
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}



class ComponentDrawer extends HTMLElement {
  constructor() {
    super();

    this.overlay = this.querySelector('.drawer-overlay');
    this.drawer = this.querySelector('.drawer-content');
    this.closeButton = this.querySelector('.close-drawer-btn');
    this.triggerButton = null;

    this.overlay.addEventListener('click', () => this.close());
    this.closeButton.addEventListener('click', () => this.close());
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
  }

  connectedCallback() {
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'dialog');
    }
    document.addEventListener('keydown', this.handleKeyPress);
  }
  
  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeyPress);
    document.removeEventListener('focus', this.trapFocus, true);
  }

  open(triggerButton) {
    this.triggerButton = triggerButton; 
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    window.ScrollLock && ScrollLock.lock('component-drawer');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.closeButton.focus();
    document.addEventListener('focus', this.trapFocus, true);
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    window.ScrollLock && ScrollLock.unlock('component-drawer');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.removeEventListener('focus', this.trapFocus, true);
  
    if (this.triggerButton) {
      this.triggerButton.focus();
      this.triggerButton = null;
    }
  }

  handleKeyPress(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
  
  trapFocus(event) {
    if (!this.contains(event.target)) {
      event.stopPropagation();
      this.closeButton.focus();
    }
  }

  static get observedAttributes() {
    return ['open'];
  }
}

customElements.define('component-drawer', ComponentDrawer);

class DrawerButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  connectedCallback() {
    this.targetId = this.getAttribute('data-target');
    this.targetDrawer = document.getElementById(this.targetId);
    
    this.setAttribute('tabindex', '0');
    this.setAttribute('role', 'button');
    
    if (this.targetDrawer) {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeyPress);
    } else {
      console.warn(`Drawer element with ID '${this.targetId}' does not exist.`);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleClick();
    }
  }

  handleClick() {
    if (this.targetDrawer && typeof this.targetDrawer.open === 'function') {
      this.targetDrawer.open(this); 
    }
  }
}

customElements.define('drawer-button', DrawerButton);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
      this.initElements();
      this.bindEvents();
    }

    initElements() {
      const modal = document.getElementById('product-quick-view');
      this.elements = {
        overlay: document.querySelector('.product-quick-view__overlay'),
        modal,
        body: document.body,
        closeButton: modal?.querySelector('.product-quick-view__close'),
        modalContent: modal?.querySelector('#product-quick-view__product-content')
      };
    }

    bindEvents() {
      const { overlay, closeButton, modal } = this.elements;
      this.addEventListener('click', this.onQuickViewClick.bind(this));
      this.addEventListener('keydown', this.onQuickViewKeydown.bind(this));
      if(closeButton){
        overlay.addEventListener('click', this.closeQuickView.bind(this));
        closeButton.addEventListener('click', this.closeQuickView.bind(this));
        document.addEventListener('keydown', this.onKeyDown.bind(this));
      }
      modal?.addEventListener('transitionend', this.onTransitionEnd.bind(this));
    }

    onKeyDown(event) {
      if (event.key === 'Escape' && this.elements.modal.classList.contains('quick-view-loaded')) {
        this.closeQuickView();
      }
    }
    onQuickViewKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); 
        this.onQuickViewClick(event);
      }
    }
    trapFocus(event) {
      if (event.key === "Tab") {
        const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusableContent = this.elements.modal.querySelectorAll(focusableElements);
        const firstFocusableElement = focusableContent[0];
        const lastFocusableElement = focusableContent[focusableContent.length - 1];

        if (event.shiftKey) { 
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
          }
        } else { 
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    }

    onTransitionEnd() {
      if (
        !this.elements.modal.classList.contains('quick-view-loaded') &&
        this.elements.modalContent.innerHTML !== ''
      ) {
        this.elements.modalContent.innerHTML = '';
      }
    }


    async onQuickViewClick(event) {
      event.preventDefault();
      const quickViewUrl = this.buildProductUrl();
    
      if (!quickViewUrl) return;
    
      this.classList.add('loading');
      this.elements.modalContent.classList.add('is-loading');
      try {
        this.cache = this.cache || {};
        if (!this.cache[quickViewUrl] || Date.now() - this.cache[quickViewUrl].timestamp > 60000) {
          const content = await this.fetchProductContent(quickViewUrl);
          this.cache[quickViewUrl] = { content, timestamp: Date.now() };
        }
        this.renderQuickView(this.cache[quickViewUrl].content, quickViewUrl);
      } finally {
        this.classList.remove('loading');
        setTimeout(() => {
          this.elements.modalContent.classList.remove('is-loading');
        }, 150);
      }
    }

    buildProductUrl() {
      const url = this.dataset.productUrl;
      if (!url) return '';
      const cleanUrl = url.split('?')[0];
      return `${cleanUrl}?view=quick-view`;
    }   

    async fetchProductContent(url) {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`[quick-view] fetch failed (${response.status})`);
      }
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const mainContent =
        doc.querySelector('#MainContent #product-quick-view__product-content') ||
        doc.querySelector('main .product-quick-view__product-content.global-radius');
      const content = mainContent?.innerHTML?.trim();
      if (!content) {
        throw new Error('[quick-view] No product content found in response');
      }
      return content;
    }

    renderQuickView(content, url) {
      if (!content?.trim()) return;
    
      this.elements.modalContent.innerHTML = content;
      requestAnimationFrame(() => {
        this.loadJavaScriptFiles();
        this.initializeShopifyComponents();
        this.openQuickView();
        this.dispatchQuickViewOpenEvent(url);
      });
    }

    loadJavaScriptFiles() {
      if (!this.loadedScripts) this.loadedScripts = new Set();
    
      this.elements.modalContent.querySelectorAll('script[src]').forEach(script => {
        if (!this.loadedScripts.has(script.src) && !document.querySelector(`script[src="${script.src}"]`)) {
          const newScript = document.createElement('script');
          newScript.src = script.src;
          newScript.async = true;
          document.head.appendChild(newScript);
          this.loadedScripts.add(script.src);
        }
      });
    }
    
    initializeShopifyComponents() {
      setTimeout(() => {
        if (Shopify?.PaymentButton) Shopify.PaymentButton.init();
        if (window.ProductModel) window.ProductModel.loadShopifyXR();
      }, 200);
    }
    
    openQuickView() {
      const { body, modal, closeButton } = this.elements;
      body.classList.add('quickview-open');
      window.ScrollLock && ScrollLock.lock('quick-view');
      modal.classList.add('quick-view-loaded');
      closeButton?.focus();
      
      if (!this.isFocusTrapped) {
        this.isFocusTrapped = true;
        document.addEventListener('keydown', this.trapFocus.bind(this));
      }
    }
    
    closeQuickView() {
      const { body, modal } = this.elements;
      body.classList.remove('quickview-open');
      window.ScrollLock && ScrollLock.unlock('quick-view');
      modal.classList.remove('quick-view-loaded');
    
      if (this.isFocusTrapped) {
        this.isFocusTrapped = false;
        document.removeEventListener('keydown', this.trapFocus.bind(this));
      }
    }
    
    

    dispatchQuickViewOpenEvent(url) {
      document.dispatchEvent(new CustomEvent('quick-view:loaded', {
        detail: { productUrl: url }
      }));
    }
  }

  customElements.define('quick-view', QuickView);
}


/**
 *  @class
 *  @function CollapsibleDetails
 */


if (!customElements.get('collapsible-details')) {
  class CollapsibleDetails extends HTMLElement {
    constructor() {
      super();
      this.toggleContent = this.toggleContent.bind(this);
      this.onTransitionEnd = this.onTransitionEnd.bind(this);
      this.updateHeight = this.updateHeight.bind(this);
      this.setResponsiveState = this.setResponsiveState.bind(this);
      this.isAnimating = false;
      this.rafId = null;
      this.resizeRafId = null;
    }

    connectedCallback() {
      this.detailsEl = this.querySelector('details');
      this.summaryEl = this.querySelector('summary');
      this.contentEl = this.querySelector('.collapsible__content');
      this.contentInnerEl = this.querySelector('.collapsible__content-inner');
      
      if (!this.detailsEl || !this.summaryEl || !this.contentEl) return;
      
      this.wrapContent();
      this.setupInitialState();
      this.addEventListeners();
      
      if (this.contentInnerEl && 'ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.debouncedUpdateHeight.bind(this));
        this.resizeObserver.observe(this.contentInnerEl);
      }
      
      if (this.detailsEl.dataset.responsive === 'true') {
        this.setResponsiveState();
        this.mediaQuery = window.matchMedia('(max-width: 1024px)');
        this.handleMediaChange = this.throttle(this.setResponsiveState, 150);
        this.mediaQuery.addEventListener('change', this.handleMediaChange);
      }
      
      if (this.contentInnerEl && 'MutationObserver' in window) {
        this.mutationObserver = new MutationObserver(
          this.throttle(this.updateContentHeight.bind(this), 100)
        );
        this.mutationObserver.observe(this.contentInnerEl, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: false
        });
      }
    }

    throttle(func, wait) {
      let timeout = null;
      let previous = 0;
      
      return (...args) => {
        const now = Date.now();
        const remaining = wait - (now - previous);
        
        if (remaining <= 0 || remaining > wait) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          previous = now;
          func.apply(this, args);
        } else if (!timeout) {
          timeout = setTimeout(() => {
            previous = Date.now();
            timeout = null;
            func.apply(this, args);
          }, remaining);
        }
      };
    }

    debouncedUpdateHeight() {
      if (this.resizeRafId) cancelAnimationFrame(this.resizeRafId);
      this.resizeRafId = requestAnimationFrame(() => {
        this.updateHeight();
        this.resizeRafId = null;
      });
    }

    wrapContent() {
      if (!this.contentEl?.parentElement) return;
      
      if (this.contentEl.parentElement.classList.contains('collapsible__content-wrapper')) {
        this.contentWrapper = this.contentEl.parentElement;
        return;
      }
      
      this.contentWrapper = document.createElement('div');
      this.contentWrapper.className = 'collapsible__content-wrapper';
      this.contentEl.parentNode.insertBefore(this.contentWrapper, this.contentEl);
      this.contentWrapper.appendChild(this.contentEl);
    }

    setupInitialState() {
      if (!this.detailsEl) return;
      
      const isOpen = this.detailsEl.hasAttribute('open');
      
      if (isOpen) {
        this.contentWrapper.style.cssText = 'height: auto';
        this.contentEl.style.transform = 'translateY(0)';
        this.detailsEl.classList.add('is-open');
      } else {
        this.contentWrapper.style.cssText = 'height: 0';
        this.contentEl.style.transform = 'translateY(16px)';
      }
    }

    addEventListeners() {
      if (!this.summaryEl || !this.contentWrapper) return;
      
      this.summaryEl.addEventListener('click', this.toggleContent);
      this.contentWrapper.addEventListener('transitionend', this.onTransitionEnd, { passive: true });
    }

    toggleContent(event) {
      event.preventDefault();
      
      if (this.isAnimating) {
        this.pendingState = !this.detailsEl.open;
        return;
      }
      
      this[this.detailsEl.open ? 'closeContent' : 'openContent']();
    }

    openContent() {
      this.isAnimating = true;
      this.detailsEl.open = true;
      
      if (this.rafId) cancelAnimationFrame(this.rafId);
      
      this.rafId = requestAnimationFrame(() => {
        const height = this.contentEl.scrollHeight;
        this.contentWrapper.style.cssText = 'height: 0';
        this.contentEl.style.transform = 'translateY(16px)';
        
        this.rafId = requestAnimationFrame(() => {
          this.detailsEl.classList.add('is-open');
          this.contentWrapper.style.height = `${height}px`;
          this.contentEl.style.transform = 'translateY(0)';
          this.rafId = null;
        });
      });
    }

    closeContent() {
      this.isAnimating = true;
      
      if (this.rafId) cancelAnimationFrame(this.rafId);
      
      this.rafId = requestAnimationFrame(() => {
        const height = this.contentWrapper.scrollHeight;
        this.contentWrapper.style.height = `${height}px`;
        
        this.rafId = requestAnimationFrame(() => {
          this.detailsEl.classList.remove('is-open');
          this.contentWrapper.style.cssText = 'height: 0';
          this.contentEl.style.transform = 'translateY(16px)';
          this.rafId = null;
        });
      });
    }

    onTransitionEnd(event) {
      if (event.propertyName !== 'height' || event.target !== this.contentWrapper) return;
      
      this.isAnimating = false;
      
      if (!this.detailsEl.classList.contains('is-open')) {
        this.detailsEl.open = false;
      } else {
        this.contentWrapper.style.height = 'auto';
      }

      if (this.pendingState !== undefined) {
        const nextState = this.pendingState;
        this.pendingState = undefined;
        this[nextState ? 'openContent' : 'closeContent']();
      }
    }

    updateHeight() {
      if (this.detailsEl.open && !this.isAnimating) {
        const height = this.contentWrapper.scrollHeight;
        this.contentWrapper.style.cssText = 'height: auto';
        this.contentWrapper.style.height = `${height}px`;
      }
    }

    updateContentHeight() {
      if (this.detailsEl.open && !this.isAnimating) {
        const height = this.contentEl.scrollHeight;
        this.contentWrapper.style.height = `${height}px`;
      }
    }

    disconnectedCallback() {
      this.summaryEl?.removeEventListener('click', this.toggleContent);
      this.contentWrapper?.removeEventListener('transitionend', this.onTransitionEnd);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      
      if (this.mediaQuery && this.handleMediaChange) {
        this.mediaQuery.removeEventListener('change', this.handleMediaChange);
      }
      
      if (this.rafId) cancelAnimationFrame(this.rafId);
      if (this.resizeRafId) cancelAnimationFrame(this.resizeRafId);
    }

    setResponsiveState() {
      const isMobile = this.mediaQuery ? this.mediaQuery.matches : 
                       window.matchMedia('(max-width: 1024px)').matches;
      
      if (isMobile && this.detailsEl.open) return;
      
      this.detailsEl.open = !isMobile;
      this.detailsEl.classList.toggle('is-open', !isMobile);
      
      if (isMobile) {
        this.contentWrapper.style.height = '0';
      } else {
        this.contentWrapper.style.cssText = 'height: auto';
        this.contentEl.style.transform = 'translateY(0)';
        
        requestAnimationFrame(() => {
          const height = this.contentEl.scrollHeight;
          this.contentWrapper.style.height = `${height}px`;
        });
      }
    }
  }
  customElements.define('collapsible-details', CollapsibleDetails);

}

// Use a debounced resize handler for better performance
function debounce(func, wait = 100) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

window.addEventListener('resize', debounce(() => {
  document.querySelectorAll('collapsible-details details[data-responsive="true"]')
    .forEach(details => details.closest('collapsible-details').setResponsiveState());
}));

/**
 *  @class
 *  @function TabsComponent
 */

if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabsHeader = this.querySelector('.tabs-header');
      this.tabsContent = this.querySelector('.tabs-content');
      this.tabActiveIndicator = this.querySelector('.indicator');

      this.tabsHeader.addEventListener('click', (e) => {
        if (e.target.classList.contains('tab-button')) {
          this.activateTab(e.target);
        }
      });

      this.tabsHeader.addEventListener('keydown', (e) => {
        if (e.target.classList.contains('tab-button')) {
          this.handleKeyDown(e);
        }
      });

      this.activateTab(this.tabsHeader.querySelector('.tab-button'));

      if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
      }
    }

    activateTab(tab) {
      const tabIndex = tab.getAttribute('data-tab');

      this.tabsHeader.querySelectorAll('.tab-button').forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-selected', isActive);
        //t.setAttribute('tabindex', isActive ? '0' : '-1'); 
      });

      this.tabsContent.querySelectorAll('.tab-content').forEach((content) => {
        content.classList.toggle('active', content.getAttribute('id') === tabIndex);
      });

      const tabRect = tab.getBoundingClientRect();
      const tabsHeaderRect = this.tabsHeader.getBoundingClientRect();
      const isRTL = getComputedStyle(this.tabsHeader).direction === 'rtl';
      const offset = isRTL
        ? tabsHeaderRect.right - tabRect.right
        : tabRect.left - tabsHeaderRect.left;

        this.tabsHeader.style.setProperty('--indicator-width', `${tabRect.width}px`);
        this.tabsHeader.style.setProperty('--indicator-offset', `${offset}px`);
    }

    handleKeyDown(e) {
      const key = e.key;
      const currentTab = e.target;
      let newTab;

      switch (key) {
        case 'ArrowRight':
          newTab = currentTab.nextElementSibling || this.tabsHeader.firstElementChild;
          break;
        case 'ArrowLeft':
          newTab = currentTab.previousElementSibling || this.tabsHeader.lastElementChild;
          break;
        case 'Enter':
        case 'Space':  
          this.activateTab(currentTab);
          return;
      }

      if (newTab && newTab.classList.contains('tab-button')) {
        e.preventDefault();
        newTab.focus(); 
      }
    }

    handleBlockSelect(e) {
      const blockId = e.detail.blockId;
      const tabToActivate = this.tabsHeader.querySelector(`[data-tab="tab-${blockId}"]`);
      if (tabToActivate) {
        this.activateTab(tabToActivate);
      }
    }
  }

  customElements.define('tabs-component', TabsComponent);
}

if (!customElements.get('card-product-swatch')) {
  class CardProductSwatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swatchButtons = this.querySelectorAll('.swatch-button');
      const card = this.closest('.card-product');
      this.image      = card.querySelector('.product-first-image img');
      this.hoverImage = card.querySelector('.product-secondary-image img');
      this.link       = card.querySelector('.product-link');

      this.swatchButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          this.handleSwatchInteraction(e.currentTarget, true);
        });

        button.addEventListener('mouseenter', (e) => {
          if (!e.currentTarget.classList.contains('active')) return;
          this.handleSwatchInteraction(e.currentTarget, false);
        });

        button.addEventListener('mouseleave', () => {
          const active = this.querySelector('.swatch-button.active');
          if (active) {
            this.updateProductImage(active);
            this.updateHoverImage(active);
            this.updateProductLink(active);
          }
        });
      });
    }

    handleSwatchInteraction(button, isClick) {
      if (isClick) {
        this.updateActiveSwatch(button);
        this.updateWishlistVariant(button);
        this.updateSizeSelection(button);
      }
      this.updateProductImage(button);
      this.updateHoverImage(button);
      this.updateProductLink(button);
    }

    /* AAS-5048: the card's size buttons are rendered per colourway and only the
     * active colour's group is visible — switch the group to the picked colour
     * (click only — hover previews must not change the size row). */
    updateSizeSelection(button) {
      const colorHandle = button.getAttribute('data-option-handle');
      if (!colorHandle) return;
      const card = this.closest('.card-product');
      const selection = card && card.querySelector('card-variant-selection');
      if (selection && typeof selection.setColor === 'function') {
        selection.setColor(colorHandle);
      }
    }

    /* AAS-4085: the card's wishlist toggles render with the default variant
     * baked into data-variant-id, so hearting after a colour pick added the
     * default colourway. Point every toggle in the card at the picked
     * colour's variant (click only — hover previews must not commit).
     * data-default-variant-id is card-variant-selection's reset baseline;
     * rebase it too so deselecting a size falls back to the picked colour. */
    updateWishlistVariant(button) {
      const variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;
      const card = this.closest('.card-product');
      if (!card) return;
      card.querySelectorAll('[data-wishlist-toggle][data-variant-id]').forEach((toggle) => {
        toggle.dataset.variantId = variantId;
        if (toggle.dataset.defaultVariantId) toggle.dataset.defaultVariantId = variantId;
      });
    }

    updateActiveSwatch(button) {
      this.swatchButtons.forEach((b) => b.classList.remove('active'));
      button.classList.add('active');
    }

    /* AAS-5556: since the retina split (AAS-5490) the card image lives inside a
     * <picture>, and a <source> outranks the <img> it wraps. Writing src/srcset
     * on the <img> alone changed the attribute and downloaded the new file while
     * the tile went on painting the OLD colour — visible in the network panel,
     * invisible on screen, and only on hi-DPI, because that is where the gated
     * source matches at all. Every swap has to move the sources too.
     *
     * The resolution-gated source carries the RETINA quality, so it takes the
     * retina ladder; an ungated one takes the standard. Falling back to the
     * standard ladder keeps a card whose markup predates the split working. */
    paintSwatchImage(scope, src, srcset, retinaSrcset) {
      const pic = scope.tagName === 'PICTURE' ? scope : scope.closest('picture');
      const img = pic ? pic.querySelector('img') : scope;
      if (pic) {
        pic.querySelectorAll('source').forEach((source) => {
          const gated = /min-resolution|device-pixel-ratio/.test(source.getAttribute('media') || '');
          const next = gated ? retinaSrcset || srcset : srcset;
          if (next) source.srcset = next;
        });
      }
      if (!img) return;
      if (srcset) img.srcset = srcset;
      if (src) img.src = src;
    }

    updateProductImage(button) {
      const newImageSrcset = button.getAttribute('data-srcset');
      const newImageSrc = button.getAttribute('data-src');
      const newRetinaSrcset = button.getAttribute('data-srcset-retina');
      const img = this.image;
      if (!img || (!newImageSrc && !newImageSrcset)) return;

      /* Same-image guard — compared against the CROSSFADE TARGET, not the
       * real img's src: during the fade window the real src is still the OLD
       * image, so hover-restore calls (mouseleave fires on every swatch)
       * aimed at the pending colour used to read as "different image",
       * cancelling and restarting the overlay on every mouse move — visible
       * strobing. With the target tracked, they're no-ops; and a genuine
       * revert to the old colour mid-fade correctly takes the crossfade path
       * (it differs from the target), cancelling the pending overlay there. */
      const currentTarget = this._imageTargetSrc || img.getAttribute('src');
      if (newImageSrc && currentTarget === newImageSrc) {
        if (newImageSrcset && !this._imageTargetSrc) {
          this.paintSwatchImage(img, null, newImageSrcset, newRetinaSrcset);
        }
        return;
      }

      /* AAS-5048: crossfade the tile on colour switch. The INCOMING image is
       * the overlay: it preloads invisibly (opacity 0) on top of the
       * untouched old image, fades in only once decoded, and only then does
       * the real node take the new src (cache-hit, instant) before the
       * overlay is removed. The old image stays fully painted underneath the
       * whole time, so no frame can show a loading gap — which is exactly
       * what the earlier clone-the-OLD-image variant got wrong (a fresh
       * clone re-runs lazy loading and blinks transparent). */
      const parent = img.parentElement;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!parent || reduceMotion) {
        this.paintSwatchImage(img, newImageSrc, newImageSrcset, newRetinaSrcset);
        this._imageTargetSrc = null;
        return;
      }

      // A newer target supersedes any in-flight fade.
      parent.querySelectorAll('.card-image-fade-clone').forEach((old) => {
        old.dataset.cancelled = 'true';
        old.remove();
      });
      this._imageTargetSrc = newImageSrc || null;

      /* Clone the whole <picture> when there is one: an extra <img> appended
       * inside a <picture> is not rendered, so the old overlay never painted
       * on a hi-DPI screen even when its file had loaded. */
      const pic = img.closest('picture');
      const host = pic ? pic.parentElement : parent;
      const overlay = (pic || img).cloneNode(true);
      const overlayImg = pic ? overlay.querySelector('img') : overlay;
      overlay.classList.add('card-image-fade-clone');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.opacity = '0';
      /* Blank the clone before it is painted. cloneNode carries the OLD colour's
       * src and srcset, and a <picture> that already has a usable candidate can
       * settle on it the moment it enters the document — the fade would then run
       * on the previous image and the new one arrive as a blink. */
      overlay.querySelectorAll('source').forEach((source) => source.removeAttribute('srcset'));
      if (overlayImg) {
        overlayImg.loading = 'eager';
        overlayImg.removeAttribute('srcset');
        overlayImg.removeAttribute('src');
      }
      /* Insert BEFORE painting. A detached <picture> does not resolve its
       * sources — `media` and `sizes` need a layout — so an overlay painted
       * while out of the document never loaded at all: decode() never settled,
       * the 1.5s fallback timer faded in an empty node, and only then did the
       * real image swap. That was the "slow fade of the same image, then a
       * blink" on search results. */
      host.appendChild(overlay);
      this.paintSwatchImage(overlay, newImageSrc, newImageSrcset, newRetinaSrcset);

      let settled = false;
      const commit = () => {
        if (settled || overlay.dataset.cancelled) return;
        settled = true;
        requestAnimationFrame(() => {
          overlay.style.opacity = '1';
        });
        setTimeout(() => {
          if (overlay.dataset.cancelled) return;
          this.paintSwatchImage(img, newImageSrc, newImageSrcset, newRetinaSrcset);
          // Only clear the target if no newer fade has claimed it meanwhile.
          if (this._imageTargetSrc === newImageSrc) this._imageTargetSrc = null;
          overlay.remove();
        }, 300);
      };
      const decodable = overlayImg || overlay;
      if (decodable.decode) decodable.decode().then(commit, commit);
      else decodable.addEventListener('load', commit, { once: true });
      setTimeout(commit, 1500);
    }

    updateHoverImage(button) {
      if (!this.hoverImage) return;
      // Same <picture> problem as the resting image — see paintSwatchImage.
      this.paintSwatchImage(
        this.hoverImage,
        button.getAttribute('data-hover-src'),
        button.getAttribute('data-hover-srcset'),
        button.getAttribute('data-hover-srcset-retina'),
      );
    }

    updateProductLink(button) {
      const newLink = button.getAttribute('data-link');
      if (newLink) {
        this.link.href = newLink;
      }
    }
  }

  customElements.define('card-product-swatch', CardProductSwatch);
}


/**
 *  @class
 *  @function CountdownTimer
 */

if (!customElements.get('count-down')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endTime = this.parseEndTime();
      this.timerId = null;
      this.elements = this.getElements();
    }

    parseEndTime() {
      const timeAttr = this.getAttribute('data-timer');
      const parsedTime = Date.parse(timeAttr);
      return isNaN(parsedTime) ? Date.now() : parsedTime;
    }

    getElements() {
      return {
        days: this.querySelector('[data-value="days"] .countdown-day'),
        hours: this.querySelector('[data-value="hours"] .countdown-hour'),
        minutes: this.querySelector('[data-value="minutes"] .countdown-minute'),
        seconds: this.querySelector('[data-value="seconds"] .countdown-second')
      };
    }

    calculateTimeRemaining() {
      const now = Date.now();
      const total = Math.max(this.endTime - now, 0);
      return {
        total,
        days: Math.floor(total / (1000 * 60 * 60 * 24)),
        hours: Math.floor((total / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((total / (1000 * 60)) % 60),
        seconds: Math.floor((total / 1000) % 60)
      };
    }

    initializeDisplay() {
      this.updateDisplay(this.calculateTimeRemaining());
    }

    startCountdown() {
      this.classList.add("active");

      this.timerId = setInterval(() => {
        const remainingTime = this.calculateTimeRemaining();

        if (remainingTime.total <= 0) {
          this.updateDisplay(remainingTime);
          this.stopCountdown();
          this.dispatchEvent(new CustomEvent('countdown-finished'));
          return;
        }

        this.updateDisplay(remainingTime);
      }, 1000);
    }

    updateDisplay(remainingTime) {
      Object.keys(this.elements).forEach(key => {
        if (this.elements[key]) {
          this.elements[key].textContent = remainingTime[key].toString().padStart(2, '0');
        }
      });
    }

    connectedCallback() {
      this.initializeDisplay();
      setTimeout(() => this.startCountdown(), 50);
    }

    disconnectedCallback() {
      this.stopCountdown();
    }

    stopCountdown() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    }
  }

  customElements.define('count-down', CountdownTimer);
}

if (!customElements.get('newsletter-form')) {
  class NewsletterForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const form = this.querySelector('form');
      if (!form) return;
      const input = form.querySelector('input[type="email"]');
      const button = form.querySelector('button[type="submit"]');
      const error = form.querySelector('.newsletter-form__message');
      const errorText = error.querySelector('.newsletter-form__message-error');
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const errorMessage = newsletterFormStrings.error;

      function validate() {
        if (!input.value) {
          error.style.display = 'none';
          errorText.textContent = '';
          button.disabled = true;
          return;
        }
        if (emailPattern.test(input.value)) {
          error.style.display = 'none';
          errorText.textContent = '';
          button.disabled = false;
        } else {
          errorText.textContent = errorMessage;
          error.style.display = 'flex';
          button.disabled = true;
        }
      }

      input.addEventListener('input', validate);

      form.addEventListener('submit', function(e) {
        if (!emailPattern.test(input.value)) {
          errorText.textContent = errorMessage;
          error.style.display = 'flex';
          button.disabled = true;
          e.preventDefault();
        } else {
          errorText.textContent = '';
          error.style.display = 'none';
          button.disabled = false;
        }
      });

      validate();
    }
  }

  customElements.define('newsletter-form', NewsletterForm);
}

if (!customElements.get('moving-button')) {
  class MovingButton extends HTMLElement {
    constructor() {
      super();
      this.button = null;
      this.buttonRect = null;
      this.proximity = 50;
      this.isEffectActive = false;
      this.targetOffsetX = 0;
      this.targetOffsetY = 0;
      this.rafId = null;

      this.handleDocumentMouseMove = this.handleDocumentMouseMove.bind(this);
      this.cacheButtonPosition = this.cacheButtonPosition.bind(this);
      this.applyCurrentTransform = this.applyCurrentTransform.bind(this);
      this.handleScrollOrResize = this.handleScrollOrResize.bind(this);
    }

    static get observedAttributes() {
      return ['data-proximity'];
    }

    connectedCallback() {
      this.button = this.querySelector(".moving-button");
      if (!this.button) {
        return;
      }

      this.updateProximityFromAttribute();

      requestAnimationFrame(() => {
        this.cacheButtonPosition();
      });

      document.addEventListener('mousemove', this.handleDocumentMouseMove);
      window.addEventListener('scroll', this.handleScrollOrResize, { passive: true });
      window.addEventListener('resize', this.handleScrollOrResize);
    }

    disconnectedCallback() {
      document.removeEventListener('mousemove', this.handleDocumentMouseMove);
      window.removeEventListener('scroll', this.handleScrollOrResize);
      window.removeEventListener('resize', this.handleScrollOrResize);

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      if (this.button && this.isEffectActive) {
        this.button.style.willChange = 'auto';
        this.button.style.transform = 'translate3d(0px, 0px, 0px)';
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-proximity') {
        this.updateProximityFromAttribute();
      }
    }

    updateProximityFromAttribute() {
      const proximityAttr = this.getAttribute('data-proximity');
      if (proximityAttr !== null) {
        const parsedProximity = parseInt(proximityAttr, 10);
        if (!isNaN(parsedProximity) && parsedProximity >= 0) {
          this.proximity = parsedProximity;
        }
      }
    }

    cacheButtonPosition() {
      if (!this.button) return;
      this.buttonRect = this.button.getBoundingClientRect();
    }

    handleScrollOrResize() {
      this.cacheButtonPosition();
    }

    applyCurrentTransform() {
      if (!this.button) return;
      this.button.style.transform = `translate3d(${this.targetOffsetX}px, ${this.targetOffsetY}px, 0px)`;
      this.rafId = null;
    }

    handleDocumentMouseMove(e) {
      if (!this.button || !this.buttonRect) {
        return;
      }

      const mouseX_viewport = e.clientX;
      const mouseY_viewport = e.clientY;

      const zoneLeft = this.buttonRect.left - this.proximity;
      const zoneTop = this.buttonRect.top - this.proximity;
      const zoneRight = this.buttonRect.right + this.proximity;
      const zoneBottom = this.buttonRect.bottom + this.proximity;

      const mouseInZone = (
        mouseX_viewport >= zoneLeft && mouseX_viewport <= zoneRight &&
        mouseY_viewport >= zoneTop && mouseY_viewport <= zoneBottom
      );

      if (mouseInZone) {
        if (!this.isEffectActive) {
          this.isEffectActive = true;
          if (this.button) this.button.style.willChange = 'transform';
        }

        const buttonCenterX_viewport = this.buttonRect.left + this.buttonRect.width / 2;
        const buttonCenterY_viewport = this.buttonRect.top + this.buttonRect.height / 2;

        let offsetX = mouseX_viewport - buttonCenterX_viewport;
        let offsetY = mouseY_viewport - buttonCenterY_viewport;

        const maxMove = 20;
        this.targetOffsetX = Math.max(-maxMove, Math.min(maxMove, offsetX));
        this.targetOffsetY = Math.max(-maxMove, Math.min(maxMove, offsetY));

        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
        }
        this.rafId = requestAnimationFrame(this.applyCurrentTransform);

      } else {
        if (this.isEffectActive) {
          this.isEffectActive = false;
          if (this.button) {
            this.button.style.willChange = 'auto';
            this.button.style.transform = 'translate3d(0px, 0px, 0px)';
          }
          if (this.rafId) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
          }
        }
      }
    }
  }

  customElements.define("moving-button", MovingButton);
}


(function() {
  function getAbsoluteTop(element) {
    if (!element) return 0;
    const rect = element.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  }

  function initSmoothScroll() {
    document.addEventListener('click', function(event) {
      if (event.target.matches('[data-anchor]')) {
        event.preventDefault();
        
        const href = event.target.getAttribute('href');
        if (!href || href === '#') return;
        
        const targetId = href.replace('#', '');
        const targetSection = document.getElementById(targetId);
        
        if (targetSection) {
          const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          const targetPosition = getAbsoluteTop(targetSection) - headerHeight;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  }

  // Init when DOM is ready
  document.addEventListener('DOMContentLoaded', initSmoothScroll);
})();

(() => {
  // Privacy Policy (and other policy pages) "jump to this headline" links.
  // Rich-text link fields only accept a URL string — editors can't target an
  // element by id — so an in-body link is authored as href="#Exact Headline
  // Text" and resolved here by matching heading text, not by DOM id. Exact
  // match first, substring match as a fallback for slightly-off wording.
  //
  // Runs in theme.js (loaded sitewide) rather than content-sections.js
  // because the SAME policy body can render inside two different hosts —
  // .content-sections__main (sections/store-policies.liquid, a custom Page
  // template) or .shopify-policy__body (Shopify's default /policies/* policy
  // template) — and only theme.js is guaranteed to load on both.
  //
  // [data-content-autonav] scopes the first host to store-policies.liquid
  // specifically — it's the flag that section sets on its wrapper (see
  // content-sections.js) and generic sections/content-sections.liquid pages
  // never set it, even though they share the same .content-sections__main
  // class. Without this scope, any plain Content Sections page (e.g. the
  // brand page) would also pick up policy-only jump-link behavior.
  const POLICY_BODY_SELECTOR = '.shopify-policy__body, [data-content-autonav] .content-sections__main';
  const HEADING_SELECTOR = ':is(h1, h2, h3, h4, h5, h6)';

  // Authored links use href="#Exact Headline Text" (spaces, punctuation and
  // all), but a hand-typed or shared URL fragment is usually slug-style
  // ("#5-delivery"). Fold hyphens/underscores and any other punctuation down
  // to spaces before comparing so both forms normalize to the same string.
  const normalizePolicyLinkText = (text) =>
    (text || '')
      .replace(/[-_]+/g, ' ')
      .replace(/[^\p{L}\p{N}\s]+/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  // Shopify's native policy rich-text link field doesn't save a bare
  // href="#Some Text" — leaving the URL field's path empty and only typing a
  // fragment gets normalized on save to href="?#Some Text" (empty query
  // string prepended). Resolve against the current location and read
  // `.hash` so both that form and a plain "#Some Text" work the same way.
  function extractSamePageFragment(href) {
    if (!href) return null;
    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (err) {
      return null;
    }
    if (url.origin !== window.location.origin) return null;
    if (url.pathname !== window.location.pathname) return null;
    if (!url.hash || url.hash.length < 2) return null;

    const raw = url.hash.slice(1);
    try {
      return decodeURIComponent(raw.replace(/\+/g, ' '));
    } catch (err) {
      return raw;
    }
  }

  function resolvePolicyHeadingByText(text) {
    const target = normalizePolicyLinkText(text);
    if (!target) return null;

    const headingEls = Array.from(
      document.querySelectorAll(`${POLICY_BODY_SELECTOR} ${HEADING_SELECTOR}`)
    );
    const exact = headingEls.find((heading) => normalizePolicyLinkText(heading.textContent) === target);
    if (exact) return exact;

    return (
      headingEls.find((heading) => {
        const headingText = normalizePolicyLinkText(heading.textContent);
        return headingText.includes(target) || target.includes(headingText);
      }) || null
    );
  }

  function initPolicyBacklinks(root) {
    const scope = root || document;
    const allAnchors = Array.from(scope.querySelectorAll(`${POLICY_BODY_SELECTOR} a[href]`));
    const links = allAnchors.filter((a) => extractSamePageFragment(a.getAttribute('href')) !== null);

    links.forEach((link) => {
      if (link.dataset.policyBacklinkBound === 'true') return;
      link.dataset.policyBacklinkBound = 'true';

      link.addEventListener('click', (e) => {
        const fragment = extractSamePageFragment(link.getAttribute('href'));
        const target = fragment ? resolvePolicyHeadingByText(fragment) : null;
        e.preventDefault();
        if (!target) {
          console.warn('[policy-backlinks] No heading found matching backlink text:', fragment);
          return;
        }

        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
  }

  // Landing directly on a URL that already carries the fragment (typed,
  // shared, or bookmarked) never fires a click, so it needs its own pass.
  // Only step in when the browser's native id-based jump didn't already
  // land somewhere — this is purely a fallback for heading-text fragments.
  function scrollToInitialPolicyHash() {
    const hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    const raw = hash.slice(1);
    if (document.getElementById(raw)) return;

    let text;
    try {
      text = decodeURIComponent(raw.replace(/\+/g, ' '));
    } catch (err) {
      text = raw;
    }

    const target = resolvePolicyHeadingByText(text);
    if (!target) return;

    const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initPolicyBacklinks();
    scrollToInitialPolicyHash();
  });
  document.addEventListener('shopify:section:load', (event) => initPolicyBacklinks(event.target));
})();

(() => {
  const copyURL = () => {
    const button = document.querySelector('.share-button__copy');
    if (!button) return;
    button.addEventListener('click', () => {
      const url = button.getAttribute('data-url');
      navigator.clipboard.writeText(url).then(() => {
        button.classList.add('copied');
        setTimeout(() => {
          button.classList.remove('copied');
        }, 2000);
      }).catch((err) => {
        console.error(err);
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => {
    copyURL();
  });
})();

if (!customElements.get('card-variant-size')) {
  customElements.define('card-variant-size', class extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      const button = event.target.closest('.variant-size-button');
      if (!button || button.disabled) return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const spinner = button.querySelector('.loading__spinner');

      this.loading = true;
      const allButtons = this.querySelectorAll('.variant-size-button');
      allButtons.forEach(btn => {
        btn.setAttribute('aria-disabled', true);
        btn.classList.add('disabled');
      });

      button.classList.add('loading');
      button.setAttribute('aria-disabled', true);
      if (spinner) spinner.classList.remove('hidden');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (this.cart?.getSectionsToRender) {
        const sections = this.cart.getSectionsToRender().map((s) => s.id);
        formData.append('sections', sections.join(','));
        formData.append('sections_url', getSectionsUrl());
        this.cart.setActiveElement?.(document.activeElement);
      }

      fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(res => {
        if (!res.ok) return res.text().then(text => { throw new Error(text); });
        return res.json();
      })
      .then(data => {
        if (data.status) {
          console.warn(data.message || data.description);
          return;
        }

        if (this.cart?.renderContents) {
          this.cart.renderContents(data);
        } else if (!document.body.classList.contains('smart-cart--enabled')) {
          window.location = window.routes.cart_url;
        }
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        allButtons.forEach(btn => {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('disabled', 'loading');
          btn.querySelector('.loading__spinner')?.classList.add('hidden');
        });
        this.loading = false;
      
        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
      });      
    }
  });
}

if (!customElements.get('show-more-toggle')) {
  customElements.define(
    'show-more-toggle',
    class ShowMoreToggle extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('[data-show-more-content]');
        this.button = this.querySelector('button');
        this.showMoreText = this.querySelector('.label-show-more');
        this.showLessText = this.querySelector('.label-show-less');

        this.button.addEventListener('click', () => this.toggle());
      }

      toggle() {
        this.content.classList.toggle('content-truncated');
        this.showMoreText.classList.toggle('hidden');
        this.showLessText.classList.toggle('hidden');
      }
    }
  );
}

if (!customElements.get('card-variant-selection')) {
  customElements.define('card-variant-selection', class extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      const sizesList = this.querySelector('.product-card__variant-sizes-list');
      this.sizeButtons = sizesList ? sizesList.querySelectorAll('.variant-selection-button') : [];
      this.addToCartButton = this.querySelector('.product-card__add-to-cart');
      this.spinner = this.addToCartButton?.querySelector('.loading__spinner');
      this.wishlistButton = this.querySelector('.product-card__wishlist-btn[data-wishlist-toggle]');

      /* AAS-5048: snapshot every colour group's server-rendered state BEFORE
       * any mutation. setColor keeps the visible row's buttons in place (so
       * the background transition can animate white↔grey) and applies the
       * picked colour's states onto them from this snapshot — the hidden
       * groups are pristine state carriers, never shown. All groups render
       * the full size union in the same order, so index alignment holds. */
      this.colorStates = {};
      this.displayButtons = [];
      this.sizeButtons.forEach((btn) => {
        const handle = btn.dataset.colorHandle;
        if (!handle) return;
        if (!this.colorStates[handle]) this.colorStates[handle] = [];
        this.colorStates[handle].push({
          variantId: btn.dataset.variantId || null,
          soldout: btn.classList.contains('is-soldout') || btn.disabled,
        });
        if (!btn.hidden) this.displayButtons.push(btn);
      });

      this.sizeButtons.forEach(btn => {
        btn.addEventListener('click', this.handleSizeSelect.bind(this));
      });

      if (this.addToCartButton) {
        this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
      }
    }

    /* Deselect any picked size and reset the add-to-cart / wishlist bindings.
     * Used by the toggle-off click below AND by setColor (AAS-5048) — a size
     * picked in one colour must not survive a switch to another colour. */
    clearSelection() {
      this.classList.remove('has-selection');
      this.sizeButtons.forEach(btn => {
        btn.classList.remove('selected');
        btn.setAttribute('aria-pressed', 'false');
      });
      if (this.addToCartButton) {
        delete this.addToCartButton.dataset.variantId;
        this.addToCartButton.setAttribute('disabled', '');
      }
      if (this.wishlistButton) {
        const defaultVariantId = this.wishlistButton.dataset.defaultVariantId;
        if (defaultVariantId) this.wishlistButton.dataset.variantId = defaultVariantId;
      }
    }

    /* AAS-5048: apply the picked colourway's availability states onto the
     * permanently-visible size row (states from the construction-time
     * snapshot). The buttons never swap, so the CSS background transition
     * animates white (available) ↔ grey (unavailable) in place. */
    setColor(colorHandle) {
      const states = this.colorStates && this.colorStates[colorHandle];
      if (!states || !this.displayButtons.length) return;
      this.displayButtons.forEach((btn, i) => {
        const state = states[i];
        if (!state) return;
        btn.classList.toggle('is-soldout', state.soldout);
        btn.disabled = state.soldout;
        if (state.soldout) btn.setAttribute('aria-disabled', 'true');
        else btn.removeAttribute('aria-disabled');
        if (state.variantId) btn.dataset.variantId = state.variantId;
        else delete btn.dataset.variantId;
      });
      this.clearSelection();
    }

    handleSizeSelect(event) {
      const button = event.currentTarget;
      if (!button || button.disabled) return;

      const wasSelected = button.classList.contains('selected');

      if (wasSelected) {
        this.clearSelection();
        return;
      }

      this.sizeButtons.forEach(btn => {
        btn.classList.remove('selected');
        btn.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('selected');
      button.setAttribute('aria-pressed', 'true');

      const variantId = button.dataset.variantId;

      if (this.addToCartButton) {
        this.addToCartButton.dataset.variantId = variantId;
        this.addToCartButton.removeAttribute('disabled');
      }

      if (this.wishlistButton) {
        if (!this.wishlistButton.dataset.defaultVariantId) {
          this.wishlistButton.dataset.defaultVariantId = this.wishlistButton.dataset.variantId;
        }
        this.wishlistButton.dataset.variantId = variantId;
      }

      this.classList.add('has-selection');
    }

    handleAddToCart(event) {
        event.preventDefault();
        const button = this.addToCartButton;
        const card = this.closest('.card-product');
        const drawer = document.getElementById('QuickAddDrawer');

        if (card && drawer?.quickAddNeedsSelection?.(card)) {
          drawer.quickAddOpen(card, button);
          return;
        }

        const variantId = button.dataset.variantId;

        if (!variantId) {
          if (card && drawer?.quickAddOpen) {
            drawer.quickAddOpen(card, button);
          }
          return;
        }

        this.loading = true;
        button.classList.add('loading');
        button.setAttribute('aria-disabled', true);
        if (this.spinner) this.spinner.classList.remove('hidden');

        // Disable size buttons while adding
        this.sizeButtons.forEach(btn => {
            btn.disabled = true;
        });

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        if (this.cart?.getSectionsToRender) {
            const sections = this.cart.getSectionsToRender().map((s) => s.id);
            formData.append('sections', sections.join(','));
            formData.append('sections_url', getSectionsUrl());
            this.cart.setActiveElement?.(document.activeElement);
        }

        fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
            'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
        })
        .then(res => {
            if (!res.ok) return res.text().then(text => { throw new Error(text); });
            return res.json();
        })
        .then(data => {
            if (data.status) {
            console.warn(data.message || data.description);
            return;
            }

            if (this.cart?.renderContents) {
            this.cart.renderContents(data);
            } else if (!document.body.classList.contains('smart-cart--enabled')) {
            window.location = window.routes.cart_url;
            }
        })
        .catch(err => {
            console.error(err);
        })
        .finally(() => {
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            if (this.spinner) this.spinner.classList.add('hidden');
            
            // Re-enable size buttons
            this.sizeButtons.forEach(btn => {
                if (!btn.classList.contains('is-soldout')) {
                     btn.disabled = false;
                }
            });

            this.loading = false;
        
            if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
            }
        }); 
    }
  });
}


// ── Toast auto-hide progress (AAS-1166) ────────────────────────────────────
// Fills the toast's surface with a white/0.2 left→right sweep lasting
// durationMs — call it exactly where the auto-hide setTimeout is armed, with
// the same duration, so the sweep IS the countdown (a changed timeout never
// drifts from the visual). surfaceSelector picks the solid pill inside a
// toast whose root is transparent (e.g. the black button); omit it when the
// toast root itself is the pill. CSS lives in theme.css (.toast-progress);
// the surface must be position:relative + overflow:hidden.
window.toastProgress = function (toast, durationMs, surfaceSelector) {
  if (!toast) return;
  const surface = surfaceSelector ? toast.querySelector(surfaceSelector) : toast;
  if (!surface) return;
  let bar = surface.querySelector(':scope > .toast-progress');
  if (!bar) {
    bar = document.createElement('span');
    bar.className = 'toast-progress';
    bar.setAttribute('aria-hidden', 'true');
    surface.appendChild(bar);
  }
  bar.classList.remove('is-running');
  bar.style.setProperty('--toast-progress-duration', durationMs + 'ms');
  void bar.offsetWidth; // commit the scaleX(0) frame so a re-show restarts from zero
  bar.classList.add('is-running');
};
